/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
!function(a,b,c,d){"use strict";function e(a,b,c){return setTimeout(j(a,c),b)}function f(a,b,c){return Array.isArray(a)?(g(a,c[b],c),!0):!1}function g(a,b,c){var e;if(a)if(a.forEach)a.forEach(b,c);else if(a.length!==d)for(e=0;e<a.length;)b.call(c,a[e],e,a),e++;else for(e in a)a.hasOwnProperty(e)&&b.call(c,a[e],e,a)}function h(b,c,d){var e="DEPRECATED METHOD: "+c+"\n"+d+" AT \n";return function(){var c=new Error("get-stack-trace"),d=c&&c.stack?c.stack.replace(/^[^\(]+?[\n$]/gm,"").replace(/^\s+at\s+/gm,"").replace(/^Object.<anonymous>\s*\(/gm,"{anonymous}()@"):"Unknown Stack Trace",f=a.console&&(a.console.warn||a.console.log);return f&&f.call(a.console,e,d),b.apply(this,arguments)}}function i(a,b,c){var d,e=b.prototype;d=a.prototype=Object.create(e),d.constructor=a,d._super=e,c&&la(d,c)}function j(a,b){return function(){return a.apply(b,arguments)}}function k(a,b){return typeof a==oa?a.apply(b?b[0]||d:d,b):a}function l(a,b){return a===d?b:a}function m(a,b,c){g(q(b),function(b){a.addEventListener(b,c,!1)})}function n(a,b,c){g(q(b),function(b){a.removeEventListener(b,c,!1)})}function o(a,b){for(;a;){if(a==b)return!0;a=a.parentNode}return!1}function p(a,b){return a.indexOf(b)>-1}function q(a){return a.trim().split(/\s+/g)}function r(a,b,c){if(a.indexOf&&!c)return a.indexOf(b);for(var d=0;d<a.length;){if(c&&a[d][c]==b||!c&&a[d]===b)return d;d++}return-1}function s(a){return Array.prototype.slice.call(a,0)}function t(a,b,c){for(var d=[],e=[],f=0;f<a.length;){var g=b?a[f][b]:a[f];r(e,g)<0&&d.push(a[f]),e[f]=g,f++}return c&&(d=b?d.sort(function(a,c){return a[b]>c[b]}):d.sort()),d}function u(a,b){for(var c,e,f=b[0].toUpperCase()+b.slice(1),g=0;g<ma.length;){if(c=ma[g],e=c?c+f:b,e in a)return e;g++}return d}function v(){return ua++}function w(b){var c=b.ownerDocument||b;return c.defaultView||c.parentWindow||a}function x(a,b){var c=this;this.manager=a,this.callback=b,this.element=a.element,this.target=a.options.inputTarget,this.domHandler=function(b){k(a.options.enable,[a])&&c.handler(b)},this.init()}function y(a){var b,c=a.options.inputClass;return new(b=c?c:xa?M:ya?P:wa?R:L)(a,z)}function z(a,b,c){var d=c.pointers.length,e=c.changedPointers.length,f=b&Ea&&d-e===0,g=b&(Ga|Ha)&&d-e===0;c.isFirst=!!f,c.isFinal=!!g,f&&(a.session={}),c.eventType=b,A(a,c),a.emit("hammer.input",c),a.recognize(c),a.session.prevInput=c}function A(a,b){var c=a.session,d=b.pointers,e=d.length;c.firstInput||(c.firstInput=D(b)),e>1&&!c.firstMultiple?c.firstMultiple=D(b):1===e&&(c.firstMultiple=!1);var f=c.firstInput,g=c.firstMultiple,h=g?g.center:f.center,i=b.center=E(d);b.timeStamp=ra(),b.deltaTime=b.timeStamp-f.timeStamp,b.angle=I(h,i),b.distance=H(h,i),B(c,b),b.offsetDirection=G(b.deltaX,b.deltaY);var j=F(b.deltaTime,b.deltaX,b.deltaY);b.overallVelocityX=j.x,b.overallVelocityY=j.y,b.overallVelocity=qa(j.x)>qa(j.y)?j.x:j.y,b.scale=g?K(g.pointers,d):1,b.rotation=g?J(g.pointers,d):0,b.maxPointers=c.prevInput?b.pointers.length>c.prevInput.maxPointers?b.pointers.length:c.prevInput.maxPointers:b.pointers.length,C(c,b);var k=a.element;o(b.srcEvent.target,k)&&(k=b.srcEvent.target),b.target=k}function B(a,b){var c=b.center,d=a.offsetDelta||{},e=a.prevDelta||{},f=a.prevInput||{};b.eventType!==Ea&&f.eventType!==Ga||(e=a.prevDelta={x:f.deltaX||0,y:f.deltaY||0},d=a.offsetDelta={x:c.x,y:c.y}),b.deltaX=e.x+(c.x-d.x),b.deltaY=e.y+(c.y-d.y)}function C(a,b){var c,e,f,g,h=a.lastInterval||b,i=b.timeStamp-h.timeStamp;if(b.eventType!=Ha&&(i>Da||h.velocity===d)){var j=b.deltaX-h.deltaX,k=b.deltaY-h.deltaY,l=F(i,j,k);e=l.x,f=l.y,c=qa(l.x)>qa(l.y)?l.x:l.y,g=G(j,k),a.lastInterval=b}else c=h.velocity,e=h.velocityX,f=h.velocityY,g=h.direction;b.velocity=c,b.velocityX=e,b.velocityY=f,b.direction=g}function D(a){for(var b=[],c=0;c<a.pointers.length;)b[c]={clientX:pa(a.pointers[c].clientX),clientY:pa(a.pointers[c].clientY)},c++;return{timeStamp:ra(),pointers:b,center:E(b),deltaX:a.deltaX,deltaY:a.deltaY}}function E(a){var b=a.length;if(1===b)return{x:pa(a[0].clientX),y:pa(a[0].clientY)};for(var c=0,d=0,e=0;b>e;)c+=a[e].clientX,d+=a[e].clientY,e++;return{x:pa(c/b),y:pa(d/b)}}function F(a,b,c){return{x:b/a||0,y:c/a||0}}function G(a,b){return a===b?Ia:qa(a)>=qa(b)?0>a?Ja:Ka:0>b?La:Ma}function H(a,b,c){c||(c=Qa);var d=b[c[0]]-a[c[0]],e=b[c[1]]-a[c[1]];return Math.sqrt(d*d+e*e)}function I(a,b,c){c||(c=Qa);var d=b[c[0]]-a[c[0]],e=b[c[1]]-a[c[1]];return 180*Math.atan2(e,d)/Math.PI}function J(a,b){return I(b[1],b[0],Ra)+I(a[1],a[0],Ra)}function K(a,b){return H(b[0],b[1],Ra)/H(a[0],a[1],Ra)}function L(){this.evEl=Ta,this.evWin=Ua,this.pressed=!1,x.apply(this,arguments)}function M(){this.evEl=Xa,this.evWin=Ya,x.apply(this,arguments),this.store=this.manager.session.pointerEvents=[]}function N(){this.evTarget=$a,this.evWin=_a,this.started=!1,x.apply(this,arguments)}function O(a,b){var c=s(a.touches),d=s(a.changedTouches);return b&(Ga|Ha)&&(c=t(c.concat(d),"identifier",!0)),[c,d]}function P(){this.evTarget=bb,this.targetIds={},x.apply(this,arguments)}function Q(a,b){var c=s(a.touches),d=this.targetIds;if(b&(Ea|Fa)&&1===c.length)return d[c[0].identifier]=!0,[c,c];var e,f,g=s(a.changedTouches),h=[],i=this.target;if(f=c.filter(function(a){return o(a.target,i)}),b===Ea)for(e=0;e<f.length;)d[f[e].identifier]=!0,e++;for(e=0;e<g.length;)d[g[e].identifier]&&h.push(g[e]),b&(Ga|Ha)&&delete d[g[e].identifier],e++;return h.length?[t(f.concat(h),"identifier",!0),h]:void 0}function R(){x.apply(this,arguments);var a=j(this.handler,this);this.touch=new P(this.manager,a),this.mouse=new L(this.manager,a),this.primaryTouch=null,this.lastTouches=[]}function S(a,b){a&Ea?(this.primaryTouch=b.changedPointers[0].identifier,T.call(this,b)):a&(Ga|Ha)&&T.call(this,b)}function T(a){var b=a.changedPointers[0];if(b.identifier===this.primaryTouch){var c={x:b.clientX,y:b.clientY};this.lastTouches.push(c);var d=this.lastTouches,e=function(){var a=d.indexOf(c);a>-1&&d.splice(a,1)};setTimeout(e,cb)}}function U(a){for(var b=a.srcEvent.clientX,c=a.srcEvent.clientY,d=0;d<this.lastTouches.length;d++){var e=this.lastTouches[d],f=Math.abs(b-e.x),g=Math.abs(c-e.y);if(db>=f&&db>=g)return!0}return!1}function V(a,b){this.manager=a,this.set(b)}function W(a){if(p(a,jb))return jb;var b=p(a,kb),c=p(a,lb);return b&&c?jb:b||c?b?kb:lb:p(a,ib)?ib:hb}function X(){if(!fb)return!1;var b={},c=a.CSS&&a.CSS.supports;return["auto","manipulation","pan-y","pan-x","pan-x pan-y","none"].forEach(function(d){b[d]=c?a.CSS.supports("touch-action",d):!0}),b}function Y(a){this.options=la({},this.defaults,a||{}),this.id=v(),this.manager=null,this.options.enable=l(this.options.enable,!0),this.state=nb,this.simultaneous={},this.requireFail=[]}function Z(a){return a&sb?"cancel":a&qb?"end":a&pb?"move":a&ob?"start":""}function $(a){return a==Ma?"down":a==La?"up":a==Ja?"left":a==Ka?"right":""}function _(a,b){var c=b.manager;return c?c.get(a):a}function aa(){Y.apply(this,arguments)}function ba(){aa.apply(this,arguments),this.pX=null,this.pY=null}function ca(){aa.apply(this,arguments)}function da(){Y.apply(this,arguments),this._timer=null,this._input=null}function ea(){aa.apply(this,arguments)}function fa(){aa.apply(this,arguments)}function ga(){Y.apply(this,arguments),this.pTime=!1,this.pCenter=!1,this._timer=null,this._input=null,this.count=0}function ha(a,b){return b=b||{},b.recognizers=l(b.recognizers,ha.defaults.preset),new ia(a,b)}function ia(a,b){this.options=la({},ha.defaults,b||{}),this.options.inputTarget=this.options.inputTarget||a,this.handlers={},this.session={},this.recognizers=[],this.oldCssProps={},this.element=a,this.input=y(this),this.touchAction=new V(this,this.options.touchAction),ja(this,!0),g(this.options.recognizers,function(a){var b=this.add(new a[0](a[1]));a[2]&&b.recognizeWith(a[2]),a[3]&&b.requireFailure(a[3])},this)}function ja(a,b){var c=a.element;if(c.style){var d;g(a.options.cssProps,function(e,f){d=u(c.style,f),b?(a.oldCssProps[d]=c.style[d],c.style[d]=e):c.style[d]=a.oldCssProps[d]||""}),b||(a.oldCssProps={})}}function ka(a,c){var d=b.createEvent("Event");d.initEvent(a,!0,!0),d.gesture=c,c.target.dispatchEvent(d)}var la,ma=["","webkit","Moz","MS","ms","o"],na=b.createElement("div"),oa="function",pa=Math.round,qa=Math.abs,ra=Date.now;la="function"!=typeof Object.assign?function(a){if(a===d||null===a)throw new TypeError("Cannot convert undefined or null to object");for(var b=Object(a),c=1;c<arguments.length;c++){var e=arguments[c];if(e!==d&&null!==e)for(var f in e)e.hasOwnProperty(f)&&(b[f]=e[f])}return b}:Object.assign;var sa=h(function(a,b,c){for(var e=Object.keys(b),f=0;f<e.length;)(!c||c&&a[e[f]]===d)&&(a[e[f]]=b[e[f]]),f++;return a},"extend","Use `assign`."),ta=h(function(a,b){return sa(a,b,!0)},"merge","Use `assign`."),ua=1,va=/mobile|tablet|ip(ad|hone|od)|android/i,wa="ontouchstart"in a,xa=u(a,"PointerEvent")!==d,ya=wa&&va.test(navigator.userAgent),za="touch",Aa="pen",Ba="mouse",Ca="kinect",Da=25,Ea=1,Fa=2,Ga=4,Ha=8,Ia=1,Ja=2,Ka=4,La=8,Ma=16,Na=Ja|Ka,Oa=La|Ma,Pa=Na|Oa,Qa=["x","y"],Ra=["clientX","clientY"];x.prototype={handler:function(){},init:function(){this.evEl&&m(this.element,this.evEl,this.domHandler),this.evTarget&&m(this.target,this.evTarget,this.domHandler),this.evWin&&m(w(this.element),this.evWin,this.domHandler)},destroy:function(){this.evEl&&n(this.element,this.evEl,this.domHandler),this.evTarget&&n(this.target,this.evTarget,this.domHandler),this.evWin&&n(w(this.element),this.evWin,this.domHandler)}};var Sa={mousedown:Ea,mousemove:Fa,mouseup:Ga},Ta="mousedown",Ua="mousemove mouseup";i(L,x,{handler:function(a){var b=Sa[a.type];b&Ea&&0===a.button&&(this.pressed=!0),b&Fa&&1!==a.which&&(b=Ga),this.pressed&&(b&Ga&&(this.pressed=!1),this.callback(this.manager,b,{pointers:[a],changedPointers:[a],pointerType:Ba,srcEvent:a}))}});var Va={pointerdown:Ea,pointermove:Fa,pointerup:Ga,pointercancel:Ha,pointerout:Ha},Wa={2:za,3:Aa,4:Ba,5:Ca},Xa="pointerdown",Ya="pointermove pointerup pointercancel";a.MSPointerEvent&&!a.PointerEvent&&(Xa="MSPointerDown",Ya="MSPointerMove MSPointerUp MSPointerCancel"),i(M,x,{handler:function(a){var b=this.store,c=!1,d=a.type.toLowerCase().replace("ms",""),e=Va[d],f=Wa[a.pointerType]||a.pointerType,g=f==za,h=r(b,a.pointerId,"pointerId");e&Ea&&(0===a.button||g)?0>h&&(b.push(a),h=b.length-1):e&(Ga|Ha)&&(c=!0),0>h||(b[h]=a,this.callback(this.manager,e,{pointers:b,changedPointers:[a],pointerType:f,srcEvent:a}),c&&b.splice(h,1))}});var Za={touchstart:Ea,touchmove:Fa,touchend:Ga,touchcancel:Ha},$a="touchstart",_a="touchstart touchmove touchend touchcancel";i(N,x,{handler:function(a){var b=Za[a.type];if(b===Ea&&(this.started=!0),this.started){var c=O.call(this,a,b);b&(Ga|Ha)&&c[0].length-c[1].length===0&&(this.started=!1),this.callback(this.manager,b,{pointers:c[0],changedPointers:c[1],pointerType:za,srcEvent:a})}}});var ab={touchstart:Ea,touchmove:Fa,touchend:Ga,touchcancel:Ha},bb="touchstart touchmove touchend touchcancel";i(P,x,{handler:function(a){var b=ab[a.type],c=Q.call(this,a,b);c&&this.callback(this.manager,b,{pointers:c[0],changedPointers:c[1],pointerType:za,srcEvent:a})}});var cb=2500,db=25;i(R,x,{handler:function(a,b,c){var d=c.pointerType==za,e=c.pointerType==Ba;if(!(e&&c.sourceCapabilities&&c.sourceCapabilities.firesTouchEvents)){if(d)S.call(this,b,c);else if(e&&U.call(this,c))return;this.callback(a,b,c)}},destroy:function(){this.touch.destroy(),this.mouse.destroy()}});var eb=u(na.style,"touchAction"),fb=eb!==d,gb="compute",hb="auto",ib="manipulation",jb="none",kb="pan-x",lb="pan-y",mb=X();V.prototype={set:function(a){a==gb&&(a=this.compute()),fb&&this.manager.element.style&&mb[a]&&(this.manager.element.style[eb]=a),this.actions=a.toLowerCase().trim()},update:function(){this.set(this.manager.options.touchAction)},compute:function(){var a=[];return g(this.manager.recognizers,function(b){k(b.options.enable,[b])&&(a=a.concat(b.getTouchAction()))}),W(a.join(" "))},preventDefaults:function(a){var b=a.srcEvent,c=a.offsetDirection;if(this.manager.session.prevented)return void b.preventDefault();var d=this.actions,e=p(d,jb)&&!mb[jb],f=p(d,lb)&&!mb[lb],g=p(d,kb)&&!mb[kb];if(e){var h=1===a.pointers.length,i=a.distance<2,j=a.deltaTime<250;if(h&&i&&j)return}return g&&f?void 0:e||f&&c&Na||g&&c&Oa?this.preventSrc(b):void 0},preventSrc:function(a){this.manager.session.prevented=!0,a.preventDefault()}};var nb=1,ob=2,pb=4,qb=8,rb=qb,sb=16,tb=32;Y.prototype={defaults:{},set:function(a){return la(this.options,a),this.manager&&this.manager.touchAction.update(),this},recognizeWith:function(a){if(f(a,"recognizeWith",this))return this;var b=this.simultaneous;return a=_(a,this),b[a.id]||(b[a.id]=a,a.recognizeWith(this)),this},dropRecognizeWith:function(a){return f(a,"dropRecognizeWith",this)?this:(a=_(a,this),delete this.simultaneous[a.id],this)},requireFailure:function(a){if(f(a,"requireFailure",this))return this;var b=this.requireFail;return a=_(a,this),-1===r(b,a)&&(b.push(a),a.requireFailure(this)),this},dropRequireFailure:function(a){if(f(a,"dropRequireFailure",this))return this;a=_(a,this);var b=r(this.requireFail,a);return b>-1&&this.requireFail.splice(b,1),this},hasRequireFailures:function(){return this.requireFail.length>0},canRecognizeWith:function(a){return!!this.simultaneous[a.id]},emit:function(a){function b(b){c.manager.emit(b,a)}var c=this,d=this.state;qb>d&&b(c.options.event+Z(d)),b(c.options.event),a.additionalEvent&&b(a.additionalEvent),d>=qb&&b(c.options.event+Z(d))},tryEmit:function(a){return this.canEmit()?this.emit(a):void(this.state=tb)},canEmit:function(){for(var a=0;a<this.requireFail.length;){if(!(this.requireFail[a].state&(tb|nb)))return!1;a++}return!0},recognize:function(a){var b=la({},a);return k(this.options.enable,[this,b])?(this.state&(rb|sb|tb)&&(this.state=nb),this.state=this.process(b),void(this.state&(ob|pb|qb|sb)&&this.tryEmit(b))):(this.reset(),void(this.state=tb))},process:function(a){},getTouchAction:function(){},reset:function(){}},i(aa,Y,{defaults:{pointers:1},attrTest:function(a){var b=this.options.pointers;return 0===b||a.pointers.length===b},process:function(a){var b=this.state,c=a.eventType,d=b&(ob|pb),e=this.attrTest(a);return d&&(c&Ha||!e)?b|sb:d||e?c&Ga?b|qb:b&ob?b|pb:ob:tb}}),i(ba,aa,{defaults:{event:"pan",threshold:10,pointers:1,direction:Pa},getTouchAction:function(){var a=this.options.direction,b=[];return a&Na&&b.push(lb),a&Oa&&b.push(kb),b},directionTest:function(a){var b=this.options,c=!0,d=a.distance,e=a.direction,f=a.deltaX,g=a.deltaY;return e&b.direction||(b.direction&Na?(e=0===f?Ia:0>f?Ja:Ka,c=f!=this.pX,d=Math.abs(a.deltaX)):(e=0===g?Ia:0>g?La:Ma,c=g!=this.pY,d=Math.abs(a.deltaY))),a.direction=e,c&&d>b.threshold&&e&b.direction},attrTest:function(a){return aa.prototype.attrTest.call(this,a)&&(this.state&ob||!(this.state&ob)&&this.directionTest(a))},emit:function(a){this.pX=a.deltaX,this.pY=a.deltaY;var b=$(a.direction);b&&(a.additionalEvent=this.options.event+b),this._super.emit.call(this,a)}}),i(ca,aa,{defaults:{event:"pinch",threshold:0,pointers:2},getTouchAction:function(){return[jb]},attrTest:function(a){return this._super.attrTest.call(this,a)&&(Math.abs(a.scale-1)>this.options.threshold||this.state&ob)},emit:function(a){if(1!==a.scale){var b=a.scale<1?"in":"out";a.additionalEvent=this.options.event+b}this._super.emit.call(this,a)}}),i(da,Y,{defaults:{event:"press",pointers:1,time:251,threshold:9},getTouchAction:function(){return[hb]},process:function(a){var b=this.options,c=a.pointers.length===b.pointers,d=a.distance<b.threshold,f=a.deltaTime>b.time;if(this._input=a,!d||!c||a.eventType&(Ga|Ha)&&!f)this.reset();else if(a.eventType&Ea)this.reset(),this._timer=e(function(){this.state=rb,this.tryEmit()},b.time,this);else if(a.eventType&Ga)return rb;return tb},reset:function(){clearTimeout(this._timer)},emit:function(a){this.state===rb&&(a&&a.eventType&Ga?this.manager.emit(this.options.event+"up",a):(this._input.timeStamp=ra(),this.manager.emit(this.options.event,this._input)))}}),i(ea,aa,{defaults:{event:"rotate",threshold:0,pointers:2},getTouchAction:function(){return[jb]},attrTest:function(a){return this._super.attrTest.call(this,a)&&(Math.abs(a.rotation)>this.options.threshold||this.state&ob)}}),i(fa,aa,{defaults:{event:"swipe",threshold:10,velocity:.3,direction:Na|Oa,pointers:1},getTouchAction:function(){return ba.prototype.getTouchAction.call(this)},attrTest:function(a){var b,c=this.options.direction;return c&(Na|Oa)?b=a.overallVelocity:c&Na?b=a.overallVelocityX:c&Oa&&(b=a.overallVelocityY),this._super.attrTest.call(this,a)&&c&a.offsetDirection&&a.distance>this.options.threshold&&a.maxPointers==this.options.pointers&&qa(b)>this.options.velocity&&a.eventType&Ga},emit:function(a){var b=$(a.offsetDirection);b&&this.manager.emit(this.options.event+b,a),this.manager.emit(this.options.event,a)}}),i(ga,Y,{defaults:{event:"tap",pointers:1,taps:1,interval:300,time:250,threshold:9,posThreshold:10},getTouchAction:function(){return[ib]},process:function(a){var b=this.options,c=a.pointers.length===b.pointers,d=a.distance<b.threshold,f=a.deltaTime<b.time;if(this.reset(),a.eventType&Ea&&0===this.count)return this.failTimeout();if(d&&f&&c){if(a.eventType!=Ga)return this.failTimeout();var g=this.pTime?a.timeStamp-this.pTime<b.interval:!0,h=!this.pCenter||H(this.pCenter,a.center)<b.posThreshold;this.pTime=a.timeStamp,this.pCenter=a.center,h&&g?this.count+=1:this.count=1,this._input=a;var i=this.count%b.taps;if(0===i)return this.hasRequireFailures()?(this._timer=e(function(){this.state=rb,this.tryEmit()},b.interval,this),ob):rb}return tb},failTimeout:function(){return this._timer=e(function(){this.state=tb},this.options.interval,this),tb},reset:function(){clearTimeout(this._timer)},emit:function(){this.state==rb&&(this._input.tapCount=this.count,this.manager.emit(this.options.event,this._input))}}),ha.VERSION="2.0.7",ha.defaults={domEvents:!1,touchAction:gb,enable:!0,inputTarget:null,inputClass:null,preset:[[ea,{enable:!1}],[ca,{enable:!1},["rotate"]],[fa,{direction:Na}],[ba,{direction:Na},["swipe"]],[ga],[ga,{event:"doubletap",taps:2},["tap"]],[da]],cssProps:{userSelect:"none",touchSelect:"none",touchCallout:"none",contentZooming:"none",userDrag:"none",tapHighlightColor:"rgba(0,0,0,0)"}};var ub=1,vb=2;ia.prototype={set:function(a){return la(this.options,a),a.touchAction&&this.touchAction.update(),a.inputTarget&&(this.input.destroy(),this.input.target=a.inputTarget,this.input.init()),this},stop:function(a){this.session.stopped=a?vb:ub},recognize:function(a){var b=this.session;if(!b.stopped){this.touchAction.preventDefaults(a);var c,d=this.recognizers,e=b.curRecognizer;(!e||e&&e.state&rb)&&(e=b.curRecognizer=null);for(var f=0;f<d.length;)c=d[f],b.stopped===vb||e&&c!=e&&!c.canRecognizeWith(e)?c.reset():c.recognize(a),!e&&c.state&(ob|pb|qb)&&(e=b.curRecognizer=c),f++}},get:function(a){if(a instanceof Y)return a;for(var b=this.recognizers,c=0;c<b.length;c++)if(b[c].options.event==a)return b[c];return null},add:function(a){if(f(a,"add",this))return this;var b=this.get(a.options.event);return b&&this.remove(b),this.recognizers.push(a),a.manager=this,this.touchAction.update(),a},remove:function(a){if(f(a,"remove",this))return this;if(a=this.get(a)){var b=this.recognizers,c=r(b,a);-1!==c&&(b.splice(c,1),this.touchAction.update())}return this},on:function(a,b){if(a!==d&&b!==d){var c=this.handlers;return g(q(a),function(a){c[a]=c[a]||[],c[a].push(b)}),this}},off:function(a,b){if(a!==d){var c=this.handlers;return g(q(a),function(a){b?c[a]&&c[a].splice(r(c[a],b),1):delete c[a]}),this}},emit:function(a,b){this.options.domEvents&&ka(a,b);var c=this.handlers[a]&&this.handlers[a].slice();if(c&&c.length){b.type=a,b.preventDefault=function(){b.srcEvent.preventDefault()};for(var d=0;d<c.length;)c[d](b),d++}},destroy:function(){this.element&&ja(this,!1),this.handlers={},this.session={},this.input.destroy(),this.element=null}},la(ha,{INPUT_START:Ea,INPUT_MOVE:Fa,INPUT_END:Ga,INPUT_CANCEL:Ha,STATE_POSSIBLE:nb,STATE_BEGAN:ob,STATE_CHANGED:pb,STATE_ENDED:qb,STATE_RECOGNIZED:rb,STATE_CANCELLED:sb,STATE_FAILED:tb,DIRECTION_NONE:Ia,DIRECTION_LEFT:Ja,DIRECTION_RIGHT:Ka,DIRECTION_UP:La,DIRECTION_DOWN:Ma,DIRECTION_HORIZONTAL:Na,DIRECTION_VERTICAL:Oa,DIRECTION_ALL:Pa,Manager:ia,Input:x,TouchAction:V,TouchInput:P,MouseInput:L,PointerEventInput:M,TouchMouseInput:R,SingleTouchInput:N,Recognizer:Y,AttrRecognizer:aa,Tap:ga,Pan:ba,Swipe:fa,Pinch:ca,Rotate:ea,Press:da,on:m,off:n,each:g,merge:ta,extend:sa,assign:la,inherit:i,bindFn:j,prefixed:u});var wb="undefined"!=typeof a?a:"undefined"!=typeof self?self:{};wb.Hammer=ha,"function"==typeof define&&define.amd?define(function(){return ha}):"undefined"!=typeof module&&module.exports?module.exports=ha:a[c]=ha}(window,document,"Hammer");
//# sourceMappingURL=hammer.min.js.map
(function ($, window) {
  const pluginName = 'pinchZoom',
    publicMethods = ['reset'];
  $.fn.pinchZoom = function (options) {
    const args = arguments,
      dataAttr = `plugin_${pluginName}`;
    return this.each(function (index, element) {
      if (typeof options === 'string') {
        if (publicMethods.indexOf(options) > -1) {
          const pinchZoom = $.data(element, dataAttr),
            method = options;
          if (pinchZoom === undefined || pinchZoom === null) {
            throw new TypeError(`pinchZoom method ${method} called on element that is not a pinchZoom!`);
          }
          pinchZoom[method].apply(pinchZoom, Array.prototype.slice.call(args, 1));
        } else {
          throw new SyntaxError(`Invalid method "${options}"`);
        }
      } else if (!$.data(this, dataAttr)) {
        const pinchZoom = Object.create(PinchZoom);
        pinchZoom.init(options, element);
        $.data(this, dataAttr, pinchZoom);
      }
      return this;
    });
  };
  $.fn.pinchZoom.options = {
    minScale: 1,
    maxScale: 6,
    wheelFactor: 0.1
  };
  let PinchZoom = {
    imageEvents: ['click', 'mousedown', 'mouseup', 'mousemove', 'mouseout', 'mouseover', 'dblclick', 'focus', 'blur'],
    init: function (options, element) {
      const self = this;
      self.options = $.extend({}, $.fn.pinchZoom.options, options);
      self.element = element;
      self.$element = $(element);
      self.$image = self.$element.children(':not(.pinchzoom__btns:not(.pinchzoom__btns--exit))');
      // ^^ need to account for images, iframes & 360;
      self.image = self.$image[0];
      self.initDimensions(); // set widths & heights after image is available
      self.addZoomElements();
      self.zooming = false;
      self.scale = 1;
      self.lastScale = 1;
      self.x = 0;
      self.lastX = 0;
      self.rangeX = 0;
      self.rangeMaxX = 0;
      self.rangeMinX = 0;
      self.y = 0;
      self.lastY = 0;
      self.rangeY = 0;
      self.rangeMaxY = 0;
      self.rangeMinY = 0;
      self.pinchStart = null;
      self.pinchZoomOrigin = undefined;
      self.adjustDeltaIssue = undefined;
      self.lastEvent = undefined;
      self.initEvents();
    },
    initDimensions: function () {
      // work around a timing issue where image is not fully loaded when this
      // plugin initializes so we end up getting 0 for width & height,
      // which causes all the zoom math to fail
      const self = this,
        interval = setInterval(waitForImage, 25);
      function waitForImage() {
        if (self.$image.width() > 0 && self.$image.height() > 0) {
          clearInterval(interval);
          self.imageWidth = self.$image.width();
          self.imageHeight = self.$image.height();
          self.viewportWidth = self.$element.width();
          self.viewportHeight = self.$element.height();
          self.currentWidth = self.imageWidth;
          self.currentHeight = self.imageHeight;
        }
      }
    },
    initEvents: function () {
      const self = this;
      hammer = self.hammerFoundry(self.element);
      self.$image.on(self.imageEvents.join(' '), function (event) {
        event.preventDefault();
        return false;
      });
      $('.pinchzoom__btns--expand').on('click', function (e) {
        self.reset();
        const parentImage = $(e.currentTarget).parents('a');
        let elem = parentImage[0];
        if (self.$element.find('.pinchzoom__btns--exit').length === 0) {
          const $backButton = $('<div class="pinchzoom__btns--exit btn btn-danger">Exit Fullscreen</div>');
          $backButton.on('click', function () {
            if (document.exitFullscreen) {
              document.exitFullscreen();
            } else if (document.webkitExitFullscreen) {
              /* Safari */
              document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) {
              /* IE11 */
              document.msExitFullscreen();
            }
            $backButton.remove();
          });
          self.$image.after($backButton);
        }
        if (elem.requestFullscreen) {
          elem.requestFullscreen();
        } else if (elem.webkitRequestFullscreen) {
          /* Safari */
          elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) {
          /* IE11 */
          elem.msRequestFullscreen();
        }
      });
      $('.pinchzoom__btns--zoomout').on('click', function () {
        self.reset();
      });
      $('.pinchzoom__btns--zoomin').on('click', function (event) {
        event.preventDefault();
        self.lastEvent = 'zoomin';
        if (self.scale < self.options.maxScale) {
          const newScale = self.clampScale(self.scale + 1),
            d = self.scaleFrom({
              x: 0,
              y: 0
            }, self.scale, newScale);
          self.scale += d.z;
          self.updateRange();
          self.x += self.clamp(d.x, self.rangeMinX, self.rangeMaxX);
          self.y += self.clamp(d.y, self.rangeMinY, self.rangeMaxY);
        }
        self.update();
        self.updateLastPos();
      });
      self.$element.on('wheel', function (event) {
        self.lastEvent = 'wheel';
        const delta = self.getWheelDelta(event.originalEvent),
          zoomOrigin = self.getRelativePosition(self.image, {
            x: event.originalEvent.pageX,
            y: event.originalEvent.pageY
          }, self.imageWidth, self.imageHeight, self.scale),
          newScale = self.clampScale(self.scale + delta * self.options.wheelFactor),
          d = self.scaleFrom(zoomOrigin, self.scale, newScale);
        self.scale += d.z;
        self.updateRange();
        self.x += self.clamp(d.x, self.rangeMinX, self.rangeMaxX);
        self.y += self.clamp(d.y, self.rangeMinY, self.rangeMaxY);
        self.update();
        self.updateLastPos();
      });
      hammer.get('pan').set();
      hammer.on('doubletap', function (event) {
        // Always start scale at 1.
        const newScale = self.scale >= 2 ? 1 : 2;

        // Set css transitions for the zoom
        self.image.style.transition = '0.3s ease-out';
        setTimeout(function () {
          self.image.style.transition = 'none';
        }, 300);
        const zoomOrigin = self.getRelativePosition(self.image, self.getCenter(event), self.imageWidth, self.imageHeight, self.scale),
          d = self.scaleFrom(zoomOrigin, self.scale, newScale);
        self.scale += d.z;
        self.updateRange();
        self.x += self.clamp(d.x, self.rangeMinX, self.rangeMaxX);
        self.y += self.clamp(d.y, self.rangeMinY, self.rangeMaxY);
        self.lastEvent = 'doubletap';
        self.update();
        // Set the last coordinates for future zooming.
        self.updateLastPos();
      }).on('pan', function (event) {
        if (self.lastEvent !== 'pan') {
          // On inital touch, use last position without adding it to the delta.
          self.adjustDeltaIssue = {
            x: event.deltaX,
            y: event.deltaY
          };
        }
        self.updateRange();
        self.x = self.clamp(self.lastX + event.deltaX - self.adjustDeltaIssue.x, self.rangeMinX, self.rangeMaxX);
        self.y = self.clamp(self.lastY + event.deltaY - self.adjustDeltaIssue.y, self.rangeMinY, self.rangeMaxY);
        self.lastEvent = 'pan';
        self.update();
      }).on('panend', function (event) {
        self.updateLastPos();
        self.lastEvent = 'panend';
      }).on('pinchstart', function (event) {
        self.pinchStart = self.getCenter(event);
        self.pinchZoomOrigin = self.getRelativePosition(self.image, {
          x: self.pinchStart.x,
          y: self.pinchStart.y
        }, self.imageWidth, self.imageHeight, self.scale);
        self.lastEvent = 'pinchstart';
      }).on('pinch', function (event) {
        const d = self.scaleFrom(self.pinchZoomOrigin, self.lastScale, self.lastScale * event.scale);
        self.x = d.x + self.lastX + event.deltaX;
        self.y = d.y + self.lastY + event.deltaY;
        self.scale = self.clampScale(d.z + self.lastScale);
        self.lastEvent = 'pinch';
        self.update();
      }).on('pinchend', function (event) {
        self.updateLastPos();
        self.lastEvent = 'pinchend';
      });
    },
    addZoomElements: function () {
      const self = this;
      const mediaType = self.$element.data('mediaType');
      //Don't add zoom buttons to videos or 360s.
      if (self.$element.find('.pinchzoom__btns').length < 1 && mediaType === 'image') {
        self.$element.each(function (i, e) {
          const zoomButtons = `<div class="pinchzoom__btns">
					<div class="pinchzoom__btns--zoomin"></div>
					<div class="pinchzoom__btns--zoomout"></div>
					<div class="pinchzoom__btns--expand"></div>
				 </div>`;
          $(e).append(zoomButtons);
        });
      }
    },
    getCenter: function (event) {
      // Hammer's event.center gives us the clientX and clientY, which only
      // works as long as the page is not scrolled.  To ensure that we get the
      // correct position of the event when the page is scrolled, we need to
      // get the average of the pageX and pageY for all the pointers involved
      // in the touch event.
      let x = 0,
        y = 0;
      for (pointer of event.pointers) {
        x += pointer.pageX;
        y += pointer.pageY;
      }
      return {
        x: Math.round(x / event.pointers.length),
        y: Math.round(y / event.pointers.length)
      };
    },
    hammerFoundry: function (element) {
      const manager = new Hammer.Manager(element);
      manager.add(new Hammer.Tap({
        event: 'doubletap',
        threshold: 10,
        taps: 2,
        posThreshold: 20
      }));
      manager.add(new Hammer.Pinch());
      manager.add(new Hammer.Pan());
      return manager;
    },
    getWheelDelta: function (event) {
      const self = this;
      let delta = event.delta || event.wheelDelta || -event.deltaY;
      if (delta === undefined) {
        delta = event.originalEvent.detail;
      }
      return self.clamp(delta, -1, 1);
    },
    getCoordinateShiftDueToScale: function (originalWidth, originalHeight, scale) {
      const newWidth = scale * originalWidth,
        newHeight = scale * originalHeight,
        dx = (newWidth - originalWidth) / 2,
        dy = (newHeight - originalHeight) / 2;
      return {
        x: dx,
        y: dy
      };
    },
    scaleFrom: function (zoomOrigin, currentScale, newScale) {
      const self = this;
      self.lastEvent === 'doubletap' && currentScale > 1 ? newScale = 1 : newScale;
      const currentShift = self.getCoordinateShiftDueToScale(self.imageWidth, self.imageHeight, currentScale),
        newShift = self.getCoordinateShiftDueToScale(self.imageWidth, self.imageHeight, newScale),
        zoomDistance = newScale - currentScale;
      self.clampScale(zoomDistance), shift = {
        x: currentShift.x - newShift.x,
        y: currentShift.y - newShift.y
      };
      let output = {
        x: zoomOrigin.x * shift.x,
        y: zoomOrigin.y * shift.y,
        z: zoomDistance
      };
      return output;
    },
    getCoords: function (elem) {
      const box = elem.getBoundingClientRect(),
        body = document.body,
        docEl = document.documentElement,
        scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop,
        scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft,
        clientTop = docEl.clientTop || body.clientTop || 0,
        clientLeft = docEl.clientLeft || body.clientLeft || 0,
        top = box.top + scrollTop - clientTop,
        left = box.left + scrollLeft - clientLeft;
      return {
        x: Math.round(left),
        y: Math.round(top)
      };
    },
    getRelativePosition: function (element, point, originalWidth, originalHeight, scale) {
      const self = this,
        domCoords = self.getCoords(element),
        elementX = point.x - domCoords.x,
        elementY = point.y - domCoords.y,
        relativeX = elementX / (originalWidth * scale / 2) - 1,
        relativeY = elementY / (originalHeight * scale / 2) - 1;
      return {
        x: relativeX,
        y: relativeY
      };
    },
    clampScale: function (newScale) {
      //Make sure the scale stays between 1 and 6
      const self = this;
      return self.clamp(newScale, self.options.minScale, self.options.maxScale);
    },
    clamp: function (value, min, max) {
      // Calculate how far you can move the image in any direction
      // Stops image from going outside parent container
      return Math.min(Math.max(min, value), max);
    },
    updateRange: function () {
      // find boundaries of image
      const self = this;
      self.rangeX = Math.max(0, Math.round(self.imageWidth * self.scale) - self.viewportWidth);
      self.rangeY = Math.max(0, Math.round(self.imageHeight * self.scale) - self.viewportHeight);
      self.rangeMaxX = Math.round(self.rangeX / 2);
      self.rangeMinX = 0 - self.rangeMaxX;
      self.rangeMaxY = Math.round(self.rangeY / 2);
      self.rangeMinY = 0 - self.rangeMaxY;
    },
    updateLastPos: function () {
      // record last coordinates
      const self = this;
      self.lastX = self.x;
      self.lastY = self.y;
      self.lastScale = self.scale;

      // if image is zoomed add zoom attribute
      // this disables swiping the image
      if (self.lastScale >= 1.1) {
        self.$image.attr('data-zoom', 'zoomed');
      } else {
        self.$image.attr('data-zoom', '');
      }
    },
    update: function () {
      // this actually transforms and scales
      const self = this;
      self.currentHeight = self.imageHeight * self.scale;
      self.currentWidth = self.imageWidth * self.scale;
      // If zoomed all the way out
      // Center the image back to 0, 0.
      // Prevents image from moving outside the container
      if (self.scale === 1) {
        self.x = 0;
        self.y = 0;
        self.$image.attr('data-zoom', '');
      }
      self.image.style.transform = 'translate3d(' + self.x + 'px, ' + self.y + 'px, 0) scale(' + self.scale + ')';
    },
    reset: function () {
      const self = this;
      self.zooming = false;
      self.scale = 1;
      self.lastScale = 1;
      self.x = 0;
      self.lastX = 0;
      self.y = 0;
      self.lastY = 0;
      self.pinchStart = null;
      self.pinchZoomOrigin = undefined;
      self.lastEvent = undefined;
      self.rangeX = 0;
      self.rangeMaxX = 0;
      self.rangeMinX = 0;
      self.rangeY = 0;
      self.rangeMaxY = 0;
      self.rangeMinY = 0;
      self.update();
    }
  };
})(jQuery, window);
/* jshint -W071, -W074 */
/* global jQuery:false */

/* Disabled options are:
 * W071: This function has too many statements
 * W074: This function's cyclomatic complexity is too high
 */

/*
 *	jQuery ezPlus 1.1.21
 *	Demo's and documentation:
 *	http://igorlino.github.io/elevatezoom-plus/
 *
 *	licensed under MIT license.
 *	http://en.wikipedia.org/wiki/MIT_License
 *
 */

if (typeof Object.create !== 'function') {
  Object.create = function (obj) {
    function F() {}
    F.prototype = obj;
    return new F();
  };
}
(function ($, window, document, undefined) {
  var EZP = {
    init: function (options, elem) {
      var self = this;
      var $galleries;
      self.elem = elem;
      self.$elem = $(elem);
      self.options = $.extend({}, $.fn.ezPlus.options, self.responsiveConfig(options || {}));
      self.imageSrc = self.$elem.data(self.options.attrImageZoomSrc) ? self.$elem.data(self.options.attrImageZoomSrc) : self.$elem.attr('src');
      if (!self.options.enabled) {
        return;
      }

      //TINT OVERRIDE SETTINGS
      if (self.options.tint) {
        self.options.lensColour = 'transparent'; //colour of the lens background
        self.options.lensOpacity = '1'; //opacity of the lens
      }
      //INNER OVERRIDE SETTINGS
      if (self.options.zoomType === 'inner') {
        self.options.showLens = false;
      }

      // LENS OVERRIDE SETTINGS
      if (self.options.zoomType === 'lens') {
        self.options.zoomWindowWidth = 0;
      }

      //UUID WHEN MISSING IDENTIFIER
      if (self.options.zoomId === -1) {
        self.options.zoomId = generateUUID();
      }

      //Remove alt on hover

      self.$elem.parent().removeAttr('title').removeAttr('alt');
      self.zoomImage = self.imageSrc;
      self.refresh(1);

      //Create the image swap from the gallery
      $galleries = $(self.options.gallery ? '#' + self.options.gallery : self.options.gallerySelector);
      $galleries.on('click.zoom', self.options.galleryItem, function (e) {
        //Set a class on the currently active gallery image
        if (self.options.galleryActiveClass) {
          $(self.options.galleryItem, $galleries).removeClass(self.options.galleryActiveClass);
          $(this).addClass(self.options.galleryActiveClass);
        }
        //stop any link on the a tag from working
        if (this.tagName === 'A') {
          e.preventDefault();
        }

        //call the swap image function
        if ($(this).data(self.options.attrImageZoomSrc)) {
          self.zoomImagePre = $(this).data(self.options.attrImageZoomSrc);
        } else {
          self.zoomImagePre = $(this).data('image');
        }
        self.swaptheimage($(this).data('image'), self.zoomImagePre);
        if (this.tagName === 'A') {
          return false;
        }
      });
      function generateUUID() {
        var d = new Date().getTime();
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          var r = (d + Math.random() * 16) % 16 | 0;
          d = Math.floor(d / 16);
          return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
        });
        return uuid;
      }
    },
    refresh: function (length) {
      var self = this;
      setTimeout(function () {
        self.fetch(self.imageSrc, self.$elem, self.options.minZoomLevel);
      }, length || self.options.refresh);
    },
    fetch: function (imgsrc, element, minZoom) {
      //get the image
      var self = this;
      var newImg = new Image();
      newImg.onload = function () {
        //set the large image dimensions - used to calculte ratio's
        if (newImg.width / element.width() <= minZoom) {
          self.largeWidth = element.width() * minZoom;
        } else {
          self.largeWidth = newImg.width;
        }
        if (newImg.height / element.height() <= minZoom) {
          self.largeHeight = element.height() * minZoom;
        } else {
          self.largeHeight = newImg.height;
        }
        //once image is loaded start the calls
        self.startZoom();
        self.currentImage = self.imageSrc;
        //let caller know image has been loaded
        self.options.onZoomedImageLoaded(self.$elem);
      };
      self.setImageSource(newImg, imgsrc); // this must be done AFTER setting onload

      return;
    },
    setImageSource: function (image, src) {
      //sets an image's source.
      image.src = src;
    },
    startZoom: function () {
      var self = this;
      //get dimensions of the non zoomed image
      self.nzWidth = self.$elem.width();
      self.nzHeight = self.$elem.height();

      //activated elements
      self.isWindowActive = false;
      self.isLensActive = false;
      self.isTintActive = false;
      self.overWindow = false;

      //CrossFade Wrapper
      if (self.options.imageCrossfade) {
        self.zoomWrap = self.$elem.wrap('<div style="height:' + self.nzHeight + 'px;width:' + self.nzWidth + 'px;" class="zoomWrapper" />');
        self.$elem.css('position', 'absolute');
      }
      self.zoomLock = 1;
      self.scrollingLock = false;
      self.changeBgSize = false;
      self.currentZoomLevel = self.options.zoomLevel;

      //get offset of the non zoomed image
      self.updateOffset(self);
      //calculate the width ratio of the large/small image
      self.widthRatio = self.largeWidth / self.currentZoomLevel / self.nzWidth;
      self.heightRatio = self.largeHeight / self.currentZoomLevel / self.nzHeight;
      function getWindowZoomStyle() {
        return 'display: none;' + 'position: absolute;' + 'float: left;' + 'height: ' + String(self.options.zoomWindowHeight) + 'px;' + 'width: ' + String(self.options.zoomWindowWidth) + 'px;' + 'text-align: center;' + 'border: ' + String(self.options.borderSize) + 'px solid ' + self.options.borderColour + ';' + 'background-size: ' + self.largeWidth / self.currentZoomLevel + 'px ' + self.largeHeight / self.currentZoomLevel + 'px;' + 'background-position: 0px 0px;' + 'background-repeat: no-repeat;' + 'background-color: ' + String(self.options.zoomWindowBgColour) + ';' + 'overflow: hidden;' + 'z-index: 100;';
      }

      //if window zoom
      if (self.options.zoomType === 'window') {
        self.zoomWindowStyle = getWindowZoomStyle();
      }
      function getInnerZoomStyle() {
        //has a border been put on the image? Lets cater for this
        var borderWidth = self.$elem.css('border-left-width');
        return 'display: none;' + 'position: absolute;' + 'float: left;' + 'height: ' + String(self.nzHeight) + 'px;' + 'width: ' + String(self.nzWidth) + 'px;' + 'margin-top: ' + String(borderWidth) + ';' + 'margin-left: ' + String(borderWidth) + ';' + 'border: ' + String(self.options.borderSize) + 'px solid ' + self.options.borderColour + ';' + 'background-position: 0px 0px;' + 'background-repeat: no-repeat;' + 'cursor:' + self.options.cursor + ';' + 'overflow: hidden;' + 'zindex: ' + self.options.zIndex + ";";
      }

      //if inner  zoom
      if (self.options.zoomType === 'inner') {
        self.zoomWindowStyle = getInnerZoomStyle();
      }
      function getWindowLensStyle() {
        // adjust images less than the window height

        if (self.nzHeight < self.options.zoomWindowHeight / self.heightRatio) {
          self.lensHeight = self.nzHeight;
        } else {
          self.lensHeight = String(self.options.zoomWindowHeight / self.heightRatio);
        }
        if (self.largeWidth < self.options.zoomWindowWidth) {
          self.lensWidth = self.nzWidth;
        } else {
          self.lensWidth = String(self.options.zoomWindowWidth / self.widthRatio);
        }
        return 'display: none;' + 'position: absolute;' + 'float: right;' + 'height: ' + self.lensHeight + 'px;' + 'width: ' + self.lensWidth + 'px;' + 'border: ' + self.options.lensBorderSize + 'px' + ' solid ' + self.options.lensBorderColour + ';' + 'background-position: 0px 0px;' + 'background-repeat: no-repeat;' + 'background-color: ' + self.options.lensColour + ';' + 'opacity: ' + self.options.lensOpacity + ';' + 'filter: alpha(opacity = ' + self.options.lensOpacity * 100 + ');' + 'zoom: 1;' + 'cursor:' + self.options.cursor + ';' + 'z-index: 999;' + 'overflow: hidden;';
      }

      //lens style for window zoom
      if (self.options.zoomType === 'window') {
        self.lensStyle = getWindowLensStyle();
      }

      //tint style
      self.tintStyle = 'display: block;' + 'position: absolute;' + 'height: ' + self.nzHeight + 'px;' + 'width: ' + self.nzWidth + 'px;' + 'background-color: ' + self.options.tintColour + ';' + 'filter: alpha(opacity=0);' + 'opacity: 0;';

      //lens style for lens zoom with optional round for modern browsers
      self.lensRound = '';
      if (self.options.zoomType === 'lens') {
        self.lensStyle = 'display: none;' + 'position: absolute;' + 'float: left;' + 'height:' + String(self.options.lensSize) + 'px;' + 'width:' + String(self.options.lensSize) + 'px;' + 'border: ' + String(self.options.borderSize) + 'px solid ' + self.options.borderColour + ';' + 'background-position: 0px 0px;' + 'background-repeat: no-repeat;' + 'background-color: ' + self.options.lensColour + ";" + 'cursor:' + self.options.cursor + ';';
      }

      //does not round in all browsers
      if (self.options.lensShape === 'round') {
        self.lensRound = 'border-radius: ' + String(self.options.lensSize / 2 + self.options.borderSize) + 'px;';
      }

      //create the div's                                                + ""
      //self.zoomContainer = $('<div/>').addClass('zoomContainer').css({"position":"relative", "height":self.nzHeight, "width":self.nzWidth});

      self.zoomContainer = $('<div class="zoomContainer" ' + 'uuid="' + self.options.zoomId + '"' + 'style="' + 'position: absolute;' + 'top: ' + self.nzOffset.top + 'px;' + 'left: ' + self.nzOffset.left + 'px;' + 'height: ' + self.nzHeight + 'px;' + '' + 'width: ' + self.nzWidth + 'px;' + 'z-index: ' + self.options.zIndex + '"></div>');
      if (self.$elem.attr('id')) {
        self.zoomContainer.attr('id', self.$elem.attr('id') + '-zoomContainer');
      }
      $(self.options.zoomContainerAppendTo).append(self.zoomContainer);

      //this will add overflow hidden and contrain the lens on lens mode
      if (self.options.containLensZoom && self.options.zoomType === 'lens') {
        self.zoomContainer.css('overflow', 'hidden');
      }
      if (self.options.zoomType !== 'inner') {
        self.zoomLens = $('<div class="zoomLens" style="' + self.lensStyle + self.lensRound + '">&nbsp;</div>').appendTo(self.zoomContainer).click(function () {
          self.$elem.trigger('click');
        });
        if (self.options.tint) {
          self.tintContainer = $('<div/>').addClass('tintContainer');
          self.zoomTint = $('<div class="zoomTint" style="' + self.tintStyle + '"></div>');
          self.zoomLens.wrap(self.tintContainer);
          self.zoomTintcss = self.zoomLens.after(self.zoomTint);

          //if tint enabled - set an image to show over the tint

          self.zoomTintImage = $('<img style="' + 'position: absolute;' + 'top: 0px;' + 'left: 0px;' + 'height: ' + self.nzHeight + 'px;" ' + 'width: ' + self.nzWidth + 'px; ' + 'max-width: none; ' + 'src="' + self.$elem.attr('src') + '">').appendTo(self.zoomLens).click(function () {
            self.$elem.trigger('click');
          });
        }
      }

      //create zoom window
      var targetZoomContainer = isNaN(self.options.zoomWindowPosition) ? 'body' : self.zoomContainer;
      self.zoomWindow = $('<div style="' + 'z-index: 999;' + 'top: ' + self.windowOffsetTop + 'px;' + 'left: ' + self.windowOffsetLeft + 'px;' + self.zoomWindowStyle + '" class="zoomWindow">&nbsp;</div>').appendTo(targetZoomContainer).click(function () {
        self.$elem.trigger('click');
      });
      self.zoomWindowContainer = $('<div/>').addClass('zoomWindowContainer').css('width', self.options.zoomWindowWidth);
      self.zoomWindow.wrap(self.zoomWindowContainer);

      //  self.captionStyle = "text-align: left;background-color: black;'+
      // 'color: white;font-weight: bold;padding: 10px;font-family: sans-serif;font-size: 11px";
      // self.zoomCaption = $('<div class="ezplus-caption" '+
      // 'style="'+self.captionStyle+'display: block; width: 280px;">INSERT ALT TAG</div>').appendTo(self.zoomWindow.parent());

      if (self.options.zoomType === 'lens') {
        self.zoomLens.css('background-image', 'url("' + self.imageSrc + '")');
      }
      if (self.options.zoomType === 'window') {
        self.zoomWindow.css('background-image', 'url("' + self.imageSrc + '")');
      }
      if (self.options.zoomType === 'inner') {
        self.zoomWindow.css('background-image', 'url("' + self.imageSrc + '")');
      }

      /*-------------------END THE ZOOM WINDOW AND LENS----------------------------------*/
      if (self.options.touchEnabled) {
        //touch events
        self.$elem.bind('touchmove.ezpspace', function (e) {
          e.preventDefault();
          var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
          self.setPosition(touch);
        });
        self.zoomContainer.bind('touchmove.ezpspace', function (e) {
          self.setElements('show');
          e.preventDefault();
          var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
          self.setPosition(touch);
        });
        self.zoomContainer.bind('touchend.ezpspace', function (e) {
          self.showHideWindow('hide');
          if (self.options.showLens) {
            self.showHideLens('hide');
          }
          if (self.options.tint && self.options.zoomType !== 'inner') {
            self.showHideTint('hide');
          }
        });
        self.$elem.bind('touchend.ezpspace', function (e) {
          self.showHideWindow('hide');
          if (self.options.showLens) {
            self.showHideLens('hide');
          }
          if (self.options.tint && self.options.zoomType !== 'inner') {
            self.showHideTint('hide');
          }
        });
        if (self.options.showLens) {
          self.zoomLens.bind('touchmove.ezpspace', function (e) {
            e.preventDefault();
            var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
            self.setPosition(touch);
          });
          self.zoomLens.bind('touchend.ezpspace', function (e) {
            self.showHideWindow('hide');
            if (self.options.showLens) {
              self.showHideLens('hide');
            }
            if (self.options.tint && self.options.zoomType !== 'inner') {
              self.showHideTint('hide');
            }
          });
        }
      }
      //Needed to work in IE
      self.$elem.bind('mousemove.ezpspace', function (e) {
        if (self.overWindow === false) {
          self.setElements('show');
        }
        //make sure on orientation change the setposition is not fired
        if (self.lastX !== e.clientX || self.lastY !== e.clientY) {
          self.setPosition(e);
          self.currentLoc = e;
        }
        self.lastX = e.clientX;
        self.lastY = e.clientY;
      });
      self.zoomContainer.bind('click.ezpspace touchstart.ezpspace', self.options.onImageClick);
      self.zoomContainer.bind('mousemove.ezpspace', function (e) {
        if (self.overWindow === false) {
          self.setElements('show');
        }
        mouseMoveZoomHandler(e);
      });
      function mouseMoveZoomHandler(e) {
        //self.overWindow = true;
        //make sure on orientation change the setposition is not fired
        if (self.lastX !== e.clientX || self.lastY !== e.clientY) {
          self.setPosition(e);
          self.currentLoc = e;
        }
        self.lastX = e.clientX;
        self.lastY = e.clientY;
      }
      var elementToTrack = null;
      if (self.options.zoomType !== 'inner') {
        elementToTrack = self.zoomLens;
      }
      if (self.options.tint && self.options.zoomType !== 'inner') {
        elementToTrack = self.zoomTint;
      }
      if (self.options.zoomType === 'inner') {
        elementToTrack = self.zoomWindow;
      }

      //register the mouse tracking
      if (elementToTrack) {
        elementToTrack.bind('mousemove.ezpspace', mouseMoveZoomHandler);
      }

      //  lensFadeOut: 500,  zoomTintFadeIn
      self.zoomContainer.add(self.$elem).mouseenter(function () {
        if (self.overWindow === false) {
          self.setElements('show');
        }
      }).mouseleave(function () {
        if (!self.scrollLock) {
          self.setElements('hide');
          self.options.onDestroy(self.$elem);
        }
      });
      //end ove image

      if (self.options.zoomType !== 'inner') {
        self.zoomWindow.mouseenter(function () {
          self.overWindow = true;
          self.setElements('hide');
        }).mouseleave(function () {
          self.overWindow = false;
        });
      }
      //end ove image

      // var delta = parseInt(e.originalEvent.wheelDelta || -e.originalEvent.detail);

      //      $(this).empty();
      //    return false;

      //fix for initial zoom setting
      //if (self.options.zoomLevel !== 1) {
      //    	self.changeZoomLevel(self.currentZoomLevel);
      //}
      //set the min zoomlevel
      if (self.options.minZoomLevel) {
        self.minZoomLevel = self.options.minZoomLevel;
      } else {
        self.minZoomLevel = self.options.scrollZoomIncrement * 2;
      }
      if (self.options.scrollZoom) {
        //see compatibility of mouse events at https://developer.mozilla.org/en-US/docs/Web/Events/mousewheel
        self.zoomContainer.add(self.$elem).bind('wheel DOMMouseScroll MozMousePixelScroll', function (e) {
          // in IE there is issue with firing of mouseleave - So check whether still scrolling
          // and on mouseleave check if scrolllock
          self.scrollLock = true;
          clearTimeout($.data(this, 'timer'));
          $.data(this, 'timer', setTimeout(function () {
            self.scrollLock = false;
            //do something
          }, 250));
          var theEvent = e.originalEvent.deltaY || e.originalEvent.detail * -1;

          //this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
          //   e.preventDefault();

          e.stopImmediatePropagation();
          e.stopPropagation();
          e.preventDefault();
          if (theEvent == 0) {
            // fixes last event inversion bug
            return false;
          }
          if (theEvent / 120 > 0) {
            var nextZoomLevel = parseFloat(self.currentZoomLevel) - self.options.scrollZoomIncrement;
            //scrolling up
            if (nextZoomLevel >= parseFloat(self.minZoomLevel)) {
              self.changeZoomLevel(nextZoomLevel);
            }
          } else {
            //scrolling down

            //Check if it has to maintain original zoom window aspect ratio or not
            if (!self.fullheight && !self.fullwidth || !self.options.mantainZoomAspectRatio) {
              var nextZoomLevel = parseFloat(self.currentZoomLevel) + self.options.scrollZoomIncrement;
              if (self.options.maxZoomLevel) {
                if (nextZoomLevel <= self.options.maxZoomLevel) {
                  self.changeZoomLevel(nextZoomLevel);
                }
              } else {
                //andy
                self.changeZoomLevel(nextZoomLevel);
              }
            }
          }
          return false;
        });
      }
    },
    destroy: function () {
      var self = this;
      self.$elem.unbind('ezpspace');
      $(self.zoomContainer).remove();
      if (self.options.loadingIcon && !!self.spinner && !!self.spinner.length) {
        self.spinner.remove();
        delete self.spinner;
      }
    },
    getIdentifier: function () {
      var self = this;
      return self.options.zoomId;
    },
    setElements: function (type) {
      var self = this;
      if (!self.options.zoomEnabled) {
        return false;
      }
      if (type === 'show') {
        if (self.isWindowSet) {
          if (self.options.zoomType === 'inner') {
            self.showHideWindow('show');
          }
          if (self.options.zoomType === 'window') {
            self.showHideWindow('show');
          }
          if (self.options.showLens) {
            self.showHideLens('show');
          }
          if (self.options.tint && self.options.zoomType !== 'inner') {
            self.showHideTint('show');
          }
        }
      }
      if (type === 'hide') {
        if (self.options.zoomType === 'window') {
          self.showHideWindow('hide');
        }
        if (!self.options.tint) {
          self.showHideWindow('hide');
        }
        if (self.options.showLens) {
          self.showHideLens('hide');
        }
        if (self.options.tint) {
          self.showHideTint('hide');
        }
      }
    },
    setPosition: function (e) {
      var self = this;
      if (!self.options.zoomEnabled) {
        return false;
      }

      //recaclc offset each time in case the image moves
      //this can be caused by other on page elements
      self.nzHeight = self.$elem.height();
      self.nzWidth = self.$elem.width();
      self.updateOffset(self);
      if (self.options.tint && self.options.zoomType !== 'inner') {
        self.zoomTint.css({
          top: 0,
          left: 0
        });
      }
      //set responsive
      //will checking if the image needs changing before running this code work faster?
      if (self.options.responsive && !self.options.scrollZoom) {
        if (self.options.showLens) {
          var lensHeight, lensWidth;
          if (self.nzHeight < self.options.zoomWindowWidth / self.widthRatio) {
            self.lensHeight = self.nzHeight;
          } else {
            self.lensHeight = String(self.options.zoomWindowHeight / self.heightRatio);
          }
          if (self.largeWidth < self.options.zoomWindowWidth) {
            self.lensWidth = self.nzWidth;
          } else {
            self.lensWidth = self.options.zoomWindowWidth / self.widthRatio;
          }
          self.widthRatio = self.largeWidth / self.nzWidth;
          self.heightRatio = self.largeHeight / self.nzHeight;
          if (self.options.zoomType !== 'lens') {
            //possibly dont need to keep recalcalculating
            //if the lens is heigher than the image, then set lens size to image size
            if (self.nzHeight < self.options.zoomWindowWidth / self.widthRatio) {
              self.lensHeight = self.nzHeight;
            } else {
              self.lensHeight = String(self.options.zoomWindowHeight / self.heightRatio);
            }
            if (self.nzWidth < self.options.zoomWindowHeight / self.heightRatio) {
              self.lensWidth = self.nzWidth;
            } else {
              self.lensWidth = String(self.options.zoomWindowWidth / self.widthRatio);
            }
            self.zoomLens.css({
              'width': self.lensWidth,
              'height': self.lensHeight
            });
            if (self.options.tint) {
              self.zoomTintImage.css({
                'width': self.nzWidth,
                'height': self.nzHeight
              });
            }
          }
          if (self.options.zoomType === 'lens') {
            self.zoomLens.css({
              width: String(self.options.lensSize) + 'px',
              height: String(self.options.lensSize) + 'px'
            });
          }
          //end responsive image change
        }
      }

      //container fix
      self.zoomContainer.css({
        top: self.nzOffset.top,
        left: self.nzOffset.left,
        width: self.nzWidth,
        // new code
        height: self.nzHeight // new code
      });
      self.mouseLeft = parseInt(e.pageX - self.nzOffset.left);
      self.mouseTop = parseInt(e.pageY - self.nzOffset.top);
      //calculate the Location of the Lens

      //calculate the bound regions - but only if zoom window
      if (self.options.zoomType === 'window') {
        var zoomLensHeight = self.zoomLens.height() / 2;
        var zoomLensWidth = self.zoomLens.width() / 2;
        self.Etoppos = self.mouseTop < 0 + zoomLensHeight;
        self.Eboppos = self.mouseTop > self.nzHeight - zoomLensHeight - self.options.lensBorderSize * 2;
        self.Eloppos = self.mouseLeft < 0 + zoomLensWidth;
        self.Eroppos = self.mouseLeft > self.nzWidth - zoomLensWidth - self.options.lensBorderSize * 2;
      }
      //calculate the bound regions - but only for inner zoom
      if (self.options.zoomType === 'inner') {
        self.Etoppos = self.mouseTop < self.nzHeight / 2 / self.heightRatio;
        self.Eboppos = self.mouseTop > self.nzHeight - self.nzHeight / 2 / self.heightRatio;
        self.Eloppos = self.mouseLeft < 0 + self.nzWidth / 2 / self.widthRatio;
        self.Eroppos = self.mouseLeft > self.nzWidth - self.nzWidth / 2 / self.widthRatio - self.options.lensBorderSize * 2;
      }

      // if the mouse position of the slider is one of the outerbounds, then hide  window and lens
      if (self.mouseLeft < 0 || self.mouseTop < 0 || self.mouseLeft > self.nzWidth || self.mouseTop > self.nzHeight) {
        self.setElements('hide');
        return;
      }
      //else continue with operations
      else {
        //lens options
        if (self.options.showLens) {
          //		self.showHideLens('show');
          //set background position of lens
          self.lensLeftPos = String(Math.floor(self.mouseLeft - self.zoomLens.width() / 2));
          self.lensTopPos = String(Math.floor(self.mouseTop - self.zoomLens.height() / 2));
        }
        //adjust the background position if the mouse is in one of the outer regions

        //Top region
        if (self.Etoppos) {
          self.lensTopPos = 0;
        }
        //Left Region
        if (self.Eloppos) {
          self.windowLeftPos = 0;
          self.lensLeftPos = 0;
          self.tintpos = 0;
        }
        //Set bottom and right region for window mode
        if (self.options.zoomType === 'window') {
          if (self.Eboppos) {
            self.lensTopPos = Math.max(self.nzHeight - self.zoomLens.height() - self.options.lensBorderSize * 2, 0);
          }
          if (self.Eroppos) {
            self.lensLeftPos = self.nzWidth - self.zoomLens.width() - self.options.lensBorderSize * 2;
          }
        }
        //Set bottom and right region for inner mode
        if (self.options.zoomType === 'inner') {
          if (self.Eboppos) {
            self.lensTopPos = Math.max(self.nzHeight - self.options.lensBorderSize * 2, 0);
          }
          if (self.Eroppos) {
            self.lensLeftPos = self.nzWidth - self.nzWidth - self.options.lensBorderSize * 2;
          }
        }
        //if lens zoom
        if (self.options.zoomType === 'lens') {
          self.windowLeftPos = String(((e.pageX - self.nzOffset.left) * self.widthRatio - self.zoomLens.width() / 2) * -1);
          self.windowTopPos = String(((e.pageY - self.nzOffset.top) * self.heightRatio - self.zoomLens.height() / 2) * -1);
          self.zoomLens.css('background-position', self.windowLeftPos + 'px ' + self.windowTopPos + 'px');
          if (self.changeBgSize) {
            if (self.nzHeight > self.nzWidth) {
              if (self.options.zoomType === 'lens') {
                self.zoomLens.css('background-size', self.largeWidth / self.newvalueheight + 'px ' + self.largeHeight / self.newvalueheight + 'px');
              }
              self.zoomWindow.css('background-size', self.largeWidth / self.newvalueheight + 'px ' + self.largeHeight / self.newvalueheight + 'px');
            } else {
              if (self.options.zoomType === 'lens') {
                self.zoomLens.css('background-size', self.largeWidth / self.newvaluewidth + 'px ' + self.largeHeight / self.newvaluewidth + 'px');
              }
              self.zoomWindow.css('background-size', self.largeWidth / self.newvaluewidth + 'px ' + self.largeHeight / self.newvaluewidth + 'px');
            }
            self.changeBgSize = false;
          }
          self.setWindowPosition(e);
        }
        //if tint zoom
        if (self.options.tint && self.options.zoomType !== 'inner') {
          self.setTintPosition(e);
        }
        //set the css background position
        if (self.options.zoomType === 'window') {
          self.setWindowPosition(e);
        }
        if (self.options.zoomType === 'inner') {
          self.setWindowPosition(e);
        }
        if (self.options.showLens) {
          if (self.fullwidth && self.options.zoomType !== 'lens') {
            self.lensLeftPos = 0;
          }
          self.zoomLens.css({
            left: self.lensLeftPos + 'px',
            top: self.lensTopPos + 'px'
          });
        }
      } //end else
    },
    showHideZoomContainer: function (change) {
      var self = this;
      if (change === 'show') {
        if (self.zoomContainer) {
          self.zoomContainer.show();
        }
      }
      if (change === 'hide') {
        if (self.zoomContainer) {
          self.zoomContainer.hide();
        }
      }
    },
    showHideWindow: function (change) {
      var self = this;
      if (change === 'show') {
        if (!self.isWindowActive && self.zoomWindow) {
          self.options.onShow(self);
          if (self.options.zoomWindowFadeIn) {
            self.zoomWindow.stop(true, true, false).fadeIn(self.options.zoomWindowFadeIn);
          } else {
            self.zoomWindow.show();
          }
          self.isWindowActive = true;
        }
      }
      if (change === 'hide') {
        if (self.isWindowActive) {
          if (self.options.zoomWindowFadeOut) {
            self.zoomWindow.stop(true, true).fadeOut(self.options.zoomWindowFadeOut, function () {
              if (self.loop) {
                //stop moving the zoom window when zoom window is faded out
                clearInterval(self.loop);
                self.loop = false;
              }
            });
          } else {
            self.zoomWindow.hide();
          }
          self.isWindowActive = false;
        }
      }
    },
    showHideLens: function (change) {
      var self = this;
      if (change === 'show') {
        if (!self.isLensActive) {
          if (self.zoomLens) {
            if (self.options.lensFadeIn) {
              self.zoomLens.stop(true, true, false).fadeIn(self.options.lensFadeIn);
            } else {
              self.zoomLens.show();
            }
          }
          self.isLensActive = true;
        }
      }
      if (change === 'hide') {
        if (self.isLensActive) {
          if (self.zoomLens) {
            if (self.options.lensFadeOut) {
              self.zoomLens.stop(true, true).fadeOut(self.options.lensFadeOut);
            } else {
              self.zoomLens.hide();
            }
          }
          self.isLensActive = false;
        }
      }
    },
    showHideTint: function (change) {
      var self = this;
      if (change === 'show') {
        if (!self.isTintActive && self.zoomTint) {
          if (self.options.zoomTintFadeIn) {
            self.zoomTint.css('opacity', self.options.tintOpacity).animate().stop(true, true).fadeIn('slow');
          } else {
            self.zoomTint.css('opacity', self.options.tintOpacity).animate();
            self.zoomTint.show();
          }
          self.isTintActive = true;
        }
      }
      if (change === 'hide') {
        if (self.isTintActive) {
          if (self.options.zoomTintFadeOut) {
            self.zoomTint.stop(true, true).fadeOut(self.options.zoomTintFadeOut);
          } else {
            self.zoomTint.hide();
          }
          self.isTintActive = false;
        }
      }
    },
    setLensPosition: function (e) {},
    setWindowPosition: function (e) {
      //return obj.slice( 0, count );
      var self = this;
      if (!isNaN(self.options.zoomWindowPosition)) {
        switch (self.options.zoomWindowPosition) {
          case 1:
            //done
            self.windowOffsetTop = self.options.zoomWindowOffsetY; //DONE - 1
            self.windowOffsetLeft = +self.nzWidth; //DONE 1, 2, 3, 4, 16
            break;
          case 2:
            if (self.options.zoomWindowHeight > self.nzHeight) {
              //positive margin

              self.windowOffsetTop = (self.options.zoomWindowHeight / 2 - self.nzHeight / 2) * -1;
              self.windowOffsetLeft = self.nzWidth; //DONE 1, 2, 3, 4, 16
            } else {
              //negative margin
              $.noop();
            }
            break;
          case 3:
            //done
            self.windowOffsetTop = self.nzHeight - self.zoomWindow.height() - self.options.borderSize * 2; //DONE 3,9
            self.windowOffsetLeft = self.nzWidth; //DONE 1, 2, 3, 4, 16
            break;
          case 4:
            //done
            self.windowOffsetTop = self.nzHeight; //DONE - 4,5,6,7,8
            self.windowOffsetLeft = self.nzWidth; //DONE 1, 2, 3, 4, 16
            break;
          case 5:
            //done
            self.windowOffsetTop = self.nzHeight; //DONE - 4,5,6,7,8
            self.windowOffsetLeft = self.nzWidth - self.zoomWindow.width() - self.options.borderSize * 2; //DONE - 5,15
            break;
          case 6:
            if (self.options.zoomWindowHeight > self.nzHeight) {
              //positive margin
              self.windowOffsetTop = self.nzHeight; //DONE - 4,5,6,7,8

              self.windowOffsetLeft = (self.options.zoomWindowWidth / 2 - self.nzWidth / 2 + self.options.borderSize * 2) * -1;
            } else {
              //negative margin
              $.noop();
            }
            break;
          case 7:
            //done
            self.windowOffsetTop = self.nzHeight; //DONE - 4,5,6,7,8
            self.windowOffsetLeft = 0; //DONE 7, 13
            break;
          case 8:
            //done
            self.windowOffsetTop = self.nzHeight; //DONE - 4,5,6,7,8
            self.windowOffsetLeft = (self.zoomWindow.width() + self.options.borderSize * 2) * -1; //DONE 8,9,10,11,12
            break;
          case 9:
            //done
            self.windowOffsetTop = self.nzHeight - self.zoomWindow.height() - self.options.borderSize * 2; //DONE 3,9
            self.windowOffsetLeft = (self.zoomWindow.width() + self.options.borderSize * 2) * -1; //DONE 8,9,10,11,12
            break;
          case 10:
            if (self.options.zoomWindowHeight > self.nzHeight) {
              //positive margin

              self.windowOffsetTop = (self.options.zoomWindowHeight / 2 - self.nzHeight / 2) * -1;
              self.windowOffsetLeft = (self.zoomWindow.width() + self.options.borderSize * 2) * -1; //DONE 8,9,10,11,12
            } else {
              //negative margin
              $.noop();
            }
            break;
          case 11:
            self.windowOffsetTop = self.options.zoomWindowOffsetY;
            self.windowOffsetLeft = (self.zoomWindow.width() + self.options.borderSize * 2) * -1; //DONE 8,9,10,11,12
            break;
          case 12:
            //done
            self.windowOffsetTop = (self.zoomWindow.height() + self.options.borderSize * 2) * -1; //DONE 12,13,14,15,16
            self.windowOffsetLeft = (self.zoomWindow.width() + self.options.borderSize * 2) * -1; //DONE 8,9,10,11,12
            break;
          case 13:
            //done
            self.windowOffsetTop = (self.zoomWindow.height() + self.options.borderSize * 2) * -1; //DONE 12,13,14,15,16
            self.windowOffsetLeft = 0; //DONE 7, 13
            break;
          case 14:
            if (self.options.zoomWindowHeight > self.nzHeight) {
              //positive margin
              self.windowOffsetTop = (self.zoomWindow.height() + self.options.borderSize * 2) * -1; //DONE 12,13,14,15,16

              self.windowOffsetLeft = (self.options.zoomWindowWidth / 2 - self.nzWidth / 2 + self.options.borderSize * 2) * -1;
            } else {
              //negative margin
              $.noop();
            }
            break;
          case 15:
            //done
            self.windowOffsetTop = (self.zoomWindow.height() + self.options.borderSize * 2) * -1; //DONE 12,13,14,15,16
            self.windowOffsetLeft = self.nzWidth - self.zoomWindow.width() - self.options.borderSize * 2; //DONE - 5,15
            break;
          case 16:
            //done
            self.windowOffsetTop = (self.zoomWindow.height() + self.options.borderSize * 2) * -1; //DONE 12,13,14,15,16
            self.windowOffsetLeft = self.nzWidth; //DONE 1, 2, 3, 4, 16
            break;
          default:
            //done
            self.windowOffsetTop = self.options.zoomWindowOffsetY; //DONE - 1
            self.windowOffsetLeft = self.nzWidth;
          //DONE 1, 2, 3, 4, 16
        }
      } //end isNAN
      else {
        // For BC purposes, treat passed element as ID if element not found
        self.externalContainer = $(self.options.zoomWindowPosition);
        if (!self.externalContainer.length) {
          self.externalContainer = $('#' + self.options.zoomWindowPosition);
        }
        self.externalContainerWidth = self.externalContainer.width();
        self.externalContainerHeight = self.externalContainer.height();
        self.externalContainerOffset = self.externalContainer.offset();
        self.windowOffsetTop = self.externalContainerOffset.top; //DONE - 1
        self.windowOffsetLeft = self.externalContainerOffset.left; //DONE 1, 2, 3, 4, 16
      }
      self.isWindowSet = true;
      self.windowOffsetTop = self.windowOffsetTop + self.options.zoomWindowOffsetY;
      self.windowOffsetLeft = self.windowOffsetLeft + self.options.zoomWindowOffsetX;
      self.zoomWindow.css({
        top: self.windowOffsetTop,
        left: self.windowOffsetLeft
      });
      if (self.options.zoomType === 'inner') {
        self.zoomWindow.css({
          top: 0,
          left: 0
        });
      }
      self.windowLeftPos = String(((e.pageX - self.nzOffset.left) * self.widthRatio - self.zoomWindow.width() / 2) * -1);
      self.windowTopPos = String(((e.pageY - self.nzOffset.top) * self.heightRatio - self.zoomWindow.height() / 2) * -1);
      if (self.Etoppos) {
        self.windowTopPos = 0;
      }
      if (self.Eloppos) {
        self.windowLeftPos = 0;
      }
      if (self.Eboppos) {
        self.windowTopPos = (self.largeHeight / self.currentZoomLevel - self.zoomWindow.height()) * -1;
      }
      if (self.Eroppos) {
        self.windowLeftPos = (self.largeWidth / self.currentZoomLevel - self.zoomWindow.width()) * -1;
      }

      //stops micro movements
      if (self.fullheight) {
        self.windowTopPos = 0;
      }
      if (self.fullwidth) {
        self.windowLeftPos = 0;
      }

      //set the css background position
      if (self.options.zoomType === 'window' || self.options.zoomType === 'inner') {
        if (self.zoomLock === 1) {
          //overrides for images not zoomable
          if (self.widthRatio <= 1) {
            self.windowLeftPos = 0;
          }
          if (self.heightRatio <= 1) {
            self.windowTopPos = 0;
          }
        }
        // adjust images less than the window height

        if (self.options.zoomType === 'window') {
          if (self.largeHeight < self.options.zoomWindowHeight) {
            self.windowTopPos = 0;
          }
          if (self.largeWidth < self.options.zoomWindowWidth) {
            self.windowLeftPos = 0;
          }
        }
        //set the zoomwindow background position
        if (self.options.easing) {
          //     if(self.changeZoom){
          //           clearInterval(self.loop);
          //           self.changeZoom = false;
          //           self.loop = false;

          //            }
          //set the pos to 0 if not set
          if (!self.xp) {
            self.xp = 0;
          }
          if (!self.yp) {
            self.yp = 0;
          }
          var interval = 16;
          if (Number.isInteger(parseInt(self.options.easing))) {
            interval = parseInt(self.options.easing);
          }
          //if loop not already started, then run it
          if (!self.loop) {
            self.loop = setInterval(function () {
              //using zeno's paradox

              self.xp += (self.windowLeftPos - self.xp) / self.options.easingAmount;
              self.yp += (self.windowTopPos - self.yp) / self.options.easingAmount;
              if (self.scrollingLock) {
                clearInterval(self.loop);
                self.xp = self.windowLeftPos;
                self.yp = self.windowTopPos;
                self.xp = ((e.pageX - self.nzOffset.left) * self.widthRatio - self.zoomWindow.width() / 2) * -1;
                self.yp = ((e.pageY - self.nzOffset.top) * self.heightRatio - self.zoomWindow.height() / 2) * -1;
                if (self.changeBgSize) {
                  if (self.nzHeight > self.nzWidth) {
                    if (self.options.zoomType === 'lens') {
                      self.zoomLens.css('background-size', self.largeWidth / self.newvalueheight + 'px ' + self.largeHeight / self.newvalueheight + 'px');
                    }
                    self.zoomWindow.css('background-size', self.largeWidth / self.newvalueheight + 'px ' + self.largeHeight / self.newvalueheight + 'px');
                  } else {
                    if (self.options.zoomType !== 'lens') {
                      self.zoomLens.css('background-size', self.largeWidth / self.newvaluewidth + 'px ' + self.largeHeight / self.newvalueheight + 'px');
                    }
                    self.zoomWindow.css('background-size', self.largeWidth / self.newvaluewidth + 'px ' + self.largeHeight / self.newvaluewidth + 'px');
                  }

                  /*
                   if(!self.bgxp){self.bgxp = self.largeWidth/self.newvalue;}
                   if(!self.bgyp){self.bgyp = self.largeHeight/self.newvalue ;}
                   if (!self.bgloop){
                   self.bgloop = setInterval(function(){
                     self.bgxp += (self.largeWidth/self.newvalue  - self.bgxp) / self.options.easingAmount;
                   self.bgyp += (self.largeHeight/self.newvalue  - self.bgyp) / self.options.easingAmount;
                     self.zoomWindow.css('background-size', self.bgxp + 'px ' + self.bgyp + 'px' );
                       }, 16);
                     }
                   */
                  self.changeBgSize = false;
                }
                self.zoomWindow.css('background-position', self.windowLeftPos + 'px ' + self.windowTopPos + 'px');
                self.scrollingLock = false;
                self.loop = false;
              } else if (Math.round(Math.abs(self.xp - self.windowLeftPos) + Math.abs(self.yp - self.windowTopPos)) < 1) {
                //stops micro movements
                clearInterval(self.loop);
                self.zoomWindow.css('background-position', self.windowLeftPos + 'px ' + self.windowTopPos + 'px');
                self.loop = false;
              } else {
                if (self.changeBgSize) {
                  if (self.nzHeight > self.nzWidth) {
                    if (self.options.zoomType === 'lens') {
                      self.zoomLens.css('background-size', self.largeWidth / self.newvalueheight + 'px ' + self.largeHeight / self.newvalueheight + 'px');
                    }
                    self.zoomWindow.css('background-size', self.largeWidth / self.newvalueheight + 'px ' + self.largeHeight / self.newvalueheight + 'px');
                  } else {
                    if (self.options.zoomType !== 'lens') {
                      self.zoomLens.css('background-size', self.largeWidth / self.newvaluewidth + 'px ' + self.largeHeight / self.newvaluewidth + 'px');
                    }
                    self.zoomWindow.css('background-size', self.largeWidth / self.newvaluewidth + 'px ' + self.largeHeight / self.newvaluewidth + 'px');
                  }
                  self.changeBgSize = false;
                }
                self.zoomWindow.css('background-position', self.xp + 'px ' + self.yp + 'px');
              }
            }, interval);
          }
        } else {
          if (self.changeBgSize) {
            if (self.nzHeight > self.nzWidth) {
              if (self.options.zoomType === 'lens') {
                self.zoomLens.css('background-size', self.largeWidth / self.newvalueheight + 'px ' + self.largeHeight / self.newvalueheight + 'px');
              }
              self.zoomWindow.css('background-size', self.largeWidth / self.newvalueheight + 'px ' + self.largeHeight / self.newvalueheight + 'px');
            } else {
              if (self.options.zoomType === 'lens') {
                self.zoomLens.css('background-size', self.largeWidth / self.newvaluewidth + 'px ' + self.largeHeight / self.newvaluewidth + 'px');
              }
              if (self.largeHeight / self.newvaluewidth < self.options.zoomWindowHeight) {
                self.zoomWindow.css('background-size', self.largeWidth / self.newvaluewidth + 'px ' + self.largeHeight / self.newvaluewidth + 'px');
              } else {
                self.zoomWindow.css('background-size', self.largeWidth / self.newvalueheight + 'px ' + self.largeHeight / self.newvalueheight + 'px');
              }
            }
            self.changeBgSize = false;
          }
          self.zoomWindow.css('background-position', self.windowLeftPos + 'px ' + self.windowTopPos + 'px');
        }
      }
    },
    setTintPosition: function (e) {
      var self = this;
      var zoomLensWidth = self.zoomLens.width();
      var zoomLensHeight = self.zoomLens.height();
      self.updateOffset(self);
      self.tintpos = String((e.pageX - self.nzOffset.left - zoomLensWidth / 2) * -1);
      self.tintposy = String((e.pageY - self.nzOffset.top - zoomLensHeight / 2) * -1);
      if (self.Etoppos) {
        self.tintposy = 0;
      }
      if (self.Eloppos) {
        self.tintpos = 0;
      }
      if (self.Eboppos) {
        self.tintposy = (self.nzHeight - zoomLensHeight - self.options.lensBorderSize * 2) * -1;
      }
      if (self.Eroppos) {
        self.tintpos = (self.nzWidth - zoomLensWidth - self.options.lensBorderSize * 2) * -1;
      }
      if (self.options.tint) {
        //stops micro movements
        if (self.fullheight) {
          self.tintposy = 0;
        }
        if (self.fullwidth) {
          self.tintpos = 0;
        }
        self.zoomTintImage.css({
          'left': self.tintpos + 'px',
          'top': self.tintposy + 'px'
        });
      }
    },
    swaptheimage: function (smallimage, largeimage) {
      var self = this;
      var newImg = new Image();
      if (self.options.loadingIcon && !self.spinner) {
        var styleAttr = 'background: url(\'' + self.options.loadingIcon + '\') no-repeat center;' + 'height:' + self.nzHeight + 'px;' + 'width:' + self.nzWidth + 'px;' + 'z-index: 2000;' + 'position: absolute; ' + 'background-position: center center;';
        if (self.options.zoomType === 'inner') {
          styleAttr += 'top: 0px;';
        }
        self.spinner = $('<div class="ezp-spinner" style="' + styleAttr + '"></div>');
        self.$elem.after(self.spinner);
      } else if (self.spinner) {
        self.spinner.show();
      }
      self.options.onImageSwap(self.$elem);
      newImg.onload = function () {
        self.largeWidth = newImg.width;
        self.largeHeight = newImg.height;
        self.zoomImage = largeimage;
        self.zoomWindow.css('background-size', self.largeWidth + 'px ' + self.largeHeight + 'px');
        self.swapAction(smallimage, largeimage);
        return;
      };
      self.setImageSource(newImg, largeimage); // this must be done AFTER setting onload
    },
    swapAction: function (smallimage, largeimage) {
      var self = this;
      var elemWidth = self.$elem.width();
      var elemHeight = self.$elem.height();
      var newImg2 = new Image();
      newImg2.onload = function () {
        //re-calculate values
        self.nzHeight = newImg2.height;
        self.nzWidth = newImg2.width;
        self.options.onImageSwapComplete(self.$elem);
        self.doneCallback();
        return;
      };
      self.setImageSource(newImg2, smallimage);

      //reset the zoomlevel to that initially set in options
      self.currentZoomLevel = self.options.zoomLevel;
      self.options.maxZoomLevel = false;

      //swaps the main image
      //self.$elem.attr('src',smallimage);
      //swaps the zoom image
      if (self.options.zoomType === 'lens') {
        self.zoomLens.css('background-image', 'url("' + largeimage + '")');
      }
      if (self.options.zoomType === 'window') {
        self.zoomWindow.css('background-image', 'url("' + largeimage + '")');
      }
      if (self.options.zoomType === 'inner') {
        self.zoomWindow.css('background-image', 'url("' + largeimage + '")');
      }
      self.currentImage = largeimage;
      if (self.options.imageCrossfade) {
        var oldImg = self.$elem;
        var newImg = oldImg.clone();
        self.$elem.attr('src', smallimage);
        self.$elem.after(newImg);
        newImg.stop(true).fadeOut(self.options.imageCrossfade, function () {
          $(this).remove();
        });

        // if(self.options.zoomType === 'inner'){
        //remove any attributes on the cloned image so we can resize later
        self.$elem.width('auto').removeAttr('width');
        self.$elem.height('auto').removeAttr('height');
        //   }

        oldImg.fadeIn(self.options.imageCrossfade);
        if (self.options.tint && self.options.zoomType !== 'inner') {
          var oldImgTint = self.zoomTintImage;
          var newImgTint = oldImgTint.clone();
          self.zoomTintImage.attr('src', largeimage);
          self.zoomTintImage.after(newImgTint);
          newImgTint.stop(true).fadeOut(self.options.imageCrossfade, function () {
            $(this).remove();
          });
          oldImgTint.fadeIn(self.options.imageCrossfade);

          //self.zoomTintImage.attr('width',elem.data('image'));

          //resize the tint window
          self.zoomTint.css({
            height: elemHeight,
            width: elemWidth
          });
        }
        self.zoomContainer.css({
          'height': elemHeight,
          'width': elemWidth
        });
        if (self.options.zoomType === 'inner') {
          if (!self.options.constrainType) {
            self.zoomWrap.parent().css({
              'height': elemHeight,
              'width': elemWidth
            });
            self.zoomWindow.css({
              'height': elemHeight,
              'width': elemWidth
            });
          }
        }
        if (self.options.imageCrossfade) {
          self.zoomWrap.css({
            'height': elemHeight,
            'width': elemWidth
          });
        }
      } else {
        self.$elem.attr('src', smallimage);
        if (self.options.tint) {
          self.zoomTintImage.attr('src', largeimage);
          //self.zoomTintImage.attr('width',elem.data('image'));
          self.zoomTintImage.attr('height', elemHeight);
          //self.zoomTintImage.attr('src') = elem.data('image');
          self.zoomTintImage.css('height', elemHeight);
          self.zoomTint.css('height', elemHeight);
        }
        self.zoomContainer.css({
          'height': elemHeight,
          'width': elemWidth
        });
        if (self.options.imageCrossfade) {
          self.zoomWrap.css({
            'height': elemHeight,
            'width': elemWidth
          });
        }
      }
      if (self.options.constrainType) {
        //This will contrain the image proportions
        if (self.options.constrainType === 'height') {
          var autoWDimension = {
            'height': self.options.constrainSize,
            'width': 'auto'
          };
          self.zoomContainer.css(autoWDimension);
          if (self.options.imageCrossfade) {
            self.zoomWrap.css(autoWDimension);
            self.constwidth = self.zoomWrap.width();
          } else {
            self.$elem.css(autoWDimension);
            self.constwidth = elemWidth;
          }
          var constWDim = {
            'height': self.options.constrainSize,
            'width': self.constwidth
          };
          if (self.options.zoomType === 'inner') {
            self.zoomWrap.parent().css(constWDim);
            self.zoomWindow.css(constWDim);
          }
          if (self.options.tint) {
            self.tintContainer.css(constWDim);
            self.zoomTint.css(constWDim);
            self.zoomTintImage.css(constWDim);
          }
        }
        if (self.options.constrainType === 'width') {
          var autoHDimension = {
            'height': 'auto',
            'width': self.options.constrainSize
          };
          self.zoomContainer.css(autoHDimension);
          if (self.options.imageCrossfade) {
            self.zoomWrap.css(autoHDimension);
            self.constheight = self.zoomWrap.height();
          } else {
            self.$elem.css(autoHDimension);
            self.constheight = elemHeight;
          }
          var constHDim = {
            'height': self.constheight,
            'width': self.options.constrainSize
          };
          if (self.options.zoomType === 'inner') {
            self.zoomWrap.parent().css(constHDim);
            self.zoomWindow.css(constHDim);
          }
          if (self.options.tint) {
            self.tintContainer.css(constHDim);
            self.zoomTint.css(constHDim);
            self.zoomTintImage.css(constHDim);
          }
        }
      }
    },
    doneCallback: function () {
      var self = this;
      if (self.options.loadingIcon && !!self.spinner && !!self.spinner.length) {
        self.spinner.hide();
      }
      self.updateOffset(self);
      self.nzWidth = self.$elem.width();
      self.nzHeight = self.$elem.height();

      // reset the zoomlevel back to default
      self.currentZoomLevel = self.options.zoomLevel;

      //ratio of the large to small image
      self.widthRatio = self.largeWidth / self.nzWidth;
      self.heightRatio = self.largeHeight / self.nzHeight;

      //NEED TO ADD THE LENS SIZE FOR ROUND
      // adjust images less than the window height
      if (self.options.zoomType === 'window') {
        if (self.nzHeight < self.options.zoomWindowHeight / self.heightRatio) {
          self.lensHeight = self.nzHeight;
        } else {
          self.lensHeight = String(self.options.zoomWindowHeight / self.heightRatio);
        }
        if (self.nzWidth < self.options.zoomWindowWidth) {
          self.lensWidth = self.nzWidth;
        } else {
          self.lensWidth = self.options.zoomWindowWidth / self.widthRatio;
        }
        if (self.zoomLens) {
          self.zoomLens.css({
            'width': self.lensWidth,
            'height': self.lensHeight
          });
        }
      }
    },
    getCurrentImage: function () {
      var self = this;
      return self.zoomImage;
    },
    getGalleryList: function () {
      var self = this;
      //loop through the gallery options and set them in list for fancybox
      self.gallerylist = [];
      if (self.options.gallery) {
        $('#' + self.options.gallery + ' a').each(function () {
          var imgSrc = '';
          if ($(this).data(self.options.attrImageZoomSrc)) {
            imgSrc = $(this).data(self.options.attrImageZoomSrc);
          } else if ($(this).data('image')) {
            imgSrc = $(this).data('image');
          }
          //put the current image at the start
          if (imgSrc === self.zoomImage) {
            self.gallerylist.unshift({
              href: '' + imgSrc + '',
              title: $(this).find('img').attr('title')
            });
          } else {
            self.gallerylist.push({
              href: '' + imgSrc + '',
              title: $(this).find('img').attr('title')
            });
          }
        });
      }
      //if no gallery - return current image
      else {
        self.gallerylist.push({
          href: '' + self.zoomImage + '',
          title: $(this).find('img').attr('title')
        });
      }
      return self.gallerylist;
    },
    changeZoomLevel: function (value) {
      var self = this;

      //flag a zoom, so can adjust the easing during setPosition
      self.scrollingLock = true;

      //round to two decimal places
      self.newvalue = parseFloat(value).toFixed(2);
      var newvalue = self.newvalue;

      //maxwidth & Maxheight of the image
      var maxheightnewvalue = self.largeHeight / (self.options.zoomWindowHeight / self.nzHeight * self.nzHeight);
      var maxwidthtnewvalue = self.largeWidth / (self.options.zoomWindowWidth / self.nzWidth * self.nzWidth);

      //calculate new heightratio
      if (self.options.zoomType !== 'inner') {
        if (maxheightnewvalue <= newvalue) {
          self.heightRatio = self.largeHeight / maxheightnewvalue / self.nzHeight;
          self.newvalueheight = maxheightnewvalue;
          self.fullheight = true;
        } else {
          self.heightRatio = self.largeHeight / newvalue / self.nzHeight;
          self.newvalueheight = newvalue;
          self.fullheight = false;
        }

        // calculate new width ratio

        if (maxwidthtnewvalue <= newvalue) {
          self.widthRatio = self.largeWidth / maxwidthtnewvalue / self.nzWidth;
          self.newvaluewidth = maxwidthtnewvalue;
          self.fullwidth = true;
        } else {
          self.widthRatio = self.largeWidth / newvalue / self.nzWidth;
          self.newvaluewidth = newvalue;
          self.fullwidth = false;
        }
        if (self.options.zoomType === 'lens') {
          if (maxheightnewvalue <= newvalue) {
            self.fullwidth = true;
            self.newvaluewidth = maxheightnewvalue;
          } else {
            self.widthRatio = self.largeWidth / newvalue / self.nzWidth;
            self.newvaluewidth = newvalue;
            self.fullwidth = false;
          }
        }
      }
      if (self.options.zoomType === 'inner') {
        maxheightnewvalue = parseFloat(self.largeHeight / self.nzHeight).toFixed(2);
        maxwidthtnewvalue = parseFloat(self.largeWidth / self.nzWidth).toFixed(2);
        if (newvalue > maxheightnewvalue) {
          newvalue = maxheightnewvalue;
        }
        if (newvalue > maxwidthtnewvalue) {
          newvalue = maxwidthtnewvalue;
        }
        if (maxheightnewvalue <= newvalue) {
          self.heightRatio = self.largeHeight / newvalue / self.nzHeight;
          if (newvalue > maxheightnewvalue) {
            self.newvalueheight = maxheightnewvalue;
          } else {
            self.newvalueheight = newvalue;
          }
          self.fullheight = true;
        } else {
          self.heightRatio = self.largeHeight / newvalue / self.nzHeight;
          if (newvalue > maxheightnewvalue) {
            self.newvalueheight = maxheightnewvalue;
          } else {
            self.newvalueheight = newvalue;
          }
          self.fullheight = false;
        }
        if (maxwidthtnewvalue <= newvalue) {
          self.widthRatio = self.largeWidth / newvalue / self.nzWidth;
          if (newvalue > maxwidthtnewvalue) {
            self.newvaluewidth = maxwidthtnewvalue;
          } else {
            self.newvaluewidth = newvalue;
          }
          self.fullwidth = true;
        } else {
          self.widthRatio = self.largeWidth / newvalue / self.nzWidth;
          self.newvaluewidth = newvalue;
          self.fullwidth = false;
        }
      } //end inner
      var scrcontinue = false;
      if (self.options.zoomType === 'inner') {
        if (self.nzWidth >= self.nzHeight) {
          if (self.newvaluewidth <= maxwidthtnewvalue) {
            scrcontinue = true;
          } else {
            scrcontinue = false;
            self.fullheight = true;
            self.fullwidth = true;
          }
        }
        if (self.nzHeight > self.nzWidth) {
          if (self.newvaluewidth <= maxwidthtnewvalue) {
            scrcontinue = true;
          } else {
            scrcontinue = false;
            self.fullheight = true;
            self.fullwidth = true;
          }
        }
      }
      if (self.options.zoomType !== 'inner') {
        scrcontinue = true;
      }
      if (scrcontinue) {
        self.zoomLock = 0;
        self.changeZoom = true;

        //if lens height is less than image height
        if (self.options.zoomWindowHeight / self.heightRatio <= self.nzHeight) {
          self.currentZoomLevel = self.newvalueheight;
          if (self.options.zoomType !== 'lens' && self.options.zoomType !== 'inner') {
            self.changeBgSize = true;
            self.zoomLens.css('height', String(self.options.zoomWindowHeight / self.heightRatio) + 'px');
          }
          if (self.options.zoomType === 'lens' || self.options.zoomType === 'inner') {
            self.changeBgSize = true;
          }
        }
        if (self.options.zoomWindowWidth / self.widthRatio <= self.nzWidth) {
          if (self.options.zoomType !== 'inner') {
            if (self.newvaluewidth > self.newvalueheight) {
              self.currentZoomLevel = self.newvaluewidth;
            }
          }
          if (self.options.zoomType !== 'lens' && self.options.zoomType !== 'inner') {
            self.changeBgSize = true;
            self.zoomLens.css('width', String(self.options.zoomWindowWidth / self.widthRatio) + 'px');
          }
          if (self.options.zoomType === 'lens' || self.options.zoomType === 'inner') {
            self.changeBgSize = true;
          }
        }
        if (self.options.zoomType === 'inner') {
          self.changeBgSize = true;
          if (self.nzWidth > self.nzHeight) {
            self.currentZoomLevel = self.newvaluewidth;
          } else if (self.nzHeight >= self.nzWidth) {
            self.currentZoomLevel = self.newvaluewidth;
          }
        }
      } //under

      //sets the boundry change, called in setWindowPos
      self.setPosition(self.currentLoc);
      //
    },
    closeAll: function () {
      var self = this;
      if (self.zoomWindow) {
        self.zoomWindow.hide();
      }
      if (self.zoomLens) {
        self.zoomLens.hide();
      }
      if (self.zoomTint) {
        self.zoomTint.hide();
      }
    },
    updateOffset: function (self) {
      if (self.options.zoomContainerAppendTo != 'body') {
        self.nzOffset = self.$elem.offset();
        appendedPosition = $(self.options.zoomContainerAppendTo).offset();
        self.nzOffset.top = self.$elem.offset().top - appendedPosition.top;
        self.nzOffset.left = self.$elem.offset().left - appendedPosition.left;
      } else {
        self.nzOffset = self.$elem.offset();
      }
    },
    changeState: function (value) {
      var self = this;
      if (value === 'enable') {
        self.options.zoomEnabled = true;
      }
      if (value === 'disable') {
        self.options.zoomEnabled = false;
      }
    },
    responsiveConfig: function (options) {
      if (options.respond && options.respond.length > 0) {
        return $.extend({}, options, this.configByScreenWidth(options));
      }
      return options;
    },
    configByScreenWidth: function (options) {
      var screenWidth = $(window).width();
      var config = $.grep(options.respond, function (item) {
        var range = item.range.split('-');
        return screenWidth >= range[0] && screenWidth <= range[1];
      });
      if (config.length > 0) {
        return config[0];
      } else {
        return options;
      }
    }
  };
  $.fn.ezPlus = function (options) {
    return this.each(function () {
      var elevate = Object.create(EZP);
      elevate.init(options, this);
      $.data(this, 'ezPlus', elevate);
    });
  };
  $.fn.ezPlus.options = {
    attrImageZoomSrc: 'zoom-image',
    // attribute to plugin use for zoom
    borderColour: '#888',
    borderSize: 4,
    constrainSize: false,
    //in pixels the dimensions you want to constrain on
    constrainType: false,
    //width or height
    containLensZoom: false,
    cursor: 'inherit',
    // user should set to what they want the cursor as, if they have set a click function
    debug: false,
    easing: false,
    easingAmount: 12,
    enabled: true,
    gallery: false,
    galleryActiveClass: 'zoomGalleryActive',
    gallerySelector: false,
    galleryItem: 'a',
    imageCrossfade: false,
    lensBorderColour: '#000',
    lensBorderSize: 1,
    lensColour: 'white',
    //colour of the lens background
    lensFadeIn: false,
    lensFadeOut: false,
    lensOpacity: 0.4,
    //opacity of the lens
    lensShape: 'square',
    //can be 'round'
    lensSize: 200,
    lenszoom: false,
    loadingIcon: false,
    //http://www.example.com/spinner.gif

    // This change will allow to decide if you want to decrease
    // zoom of one of the dimensions once the other reached it's top value,
    // or keep the aspect ratio, default behaviour still being as always,
    // allow to continue zooming out, so it keeps retrocompatibility.
    mantainZoomAspectRatio: false,
    maxZoomLevel: false,
    minZoomLevel: 1.01,
    onComplete: $.noop,
    onDestroy: $.noop,
    onImageClick: $.noop,
    onImageSwap: $.noop,
    onImageSwapComplete: $.noop,
    onShow: $.noop,
    onZoomedImageLoaded: $.noop,
    preloading: 1,
    //by default, load all the images, if 0, then only load images after activated (PLACEHOLDER FOR NEXT VERSION)
    respond: [],
    responsive: true,
    scrollZoom: false,
    //allow zoom on mousewheel, true to activate
    scrollZoomIncrement: 0.1,
    //steps of the scrollzoom
    showLens: true,
    tint: false,
    //enable the tinting
    tintColour: '#333',
    //default tint color, can be anything, red, #ccc, rgb(0,0,0)
    tintOpacity: 0.4,
    //opacity of the tint
    touchEnabled: true,
    zoomActivation: 'hover',
    // Can also be click (PLACEHOLDER FOR NEXT VERSION)
    zoomContainerAppendTo: 'body',
    //zoom container parent selector
    zoomId: -1,
    // identifier for the zoom container
    zoomLevel: 1,
    //default zoom level of image
    zoomTintFadeIn: false,
    zoomTintFadeOut: false,
    zoomType: 'window',
    //window is default,  also 'lens' available -
    zoomWindowAlwaysShow: false,
    zoomWindowBgColour: '#fff',
    zoomWindowFadeIn: false,
    zoomWindowFadeOut: false,
    zoomWindowHeight: 400,
    zoomWindowOffsetX: 0,
    zoomWindowOffsetY: 0,
    zoomWindowPosition: 1,
    //Possible values: 1-16, but we can also position with a selector string.
    zoomWindowWidth: 400,
    zoomEnabled: true,
    //false disables zoomwindow from showing
    zIndex: 999
  };
})(jQuery, window, document);
/**
 *
 * jquery.view360.js
 * This jQuery plugin provides the image rotation for 360 images
 *
 * High Level Idea: The page is virtually split into sections,
 * with each marker being a "sectionWidth" from the next. When the mouse
 * horizontal movements pass a "marker" then the current image counter
 * increments to the next image.
 *
 **/
(function ($, window, undefined) {
  $.fn.view360 = function (options) {
    return this.each(function (index, element) {
      let viewer = Object.create(Viewer);
      viewer.init(options, element);
      $.data(this, 'view360', viewer);
      return this;
    });
  };
  $.fn.view360.options = {
    /**
     * A multiplier that can control how big each section is,
     * thereby controlling how fast the image rotation will be
     **/
    speedFactor: 10
  };
  let Viewer = {
    init: function (options, element) {
      const self = this;
      self.options = $.extend({}, $.fn.view360.options, options);
      const $element = $(element);
      const $imagesList = $element.find('img');
      const imageCount = $imagesList.length;
      const $firstImage = $imagesList.first();
      const imageWidth = $firstImage.width();
      // Prevents rotations from mouse movements, need to trigger the mousedown event
      let allowMove = false;
      // The previous position
      let previousMarker = 0;
      // The current position with respect to the mouse x position and the sectionWidth
      let currentMarker = 0;
      // The current image that is being displayed for this step
      let currentImage = 0;

      // The amount of space from one marker to the next
      let sectionWidth = parseInt(imageWidth / (imageCount * self.options.speedFactor));
      $element.css('visibility', 'visible');
      $imagesList.hide();
      $firstImage.show();
      $('#zoom-div').css('visibility', 'visible');
      Viewer.grab($imagesList);
      $element.on('mousedown.view360 touchstart.view360', function (event) {
        const self = this;
        if (!$(self).parent('div').attr('zoomed') || $(this).parent('div').attr('zoomed') == 'false') {
          Viewer.grabbing($imagesList);
          currentMarker = parseInt(event.pageX / sectionWidth);
          previousMarker = currentMarker;
          allowMove = true;
        }

        // Attach mousemove event within the mousedown
        $element.on('mousemove.view360 touchmove.view360', function (event) {
          event.preventDefault();
          if (allowMove) {
            let pageX = 0;
            if (event.type === 'mousemove') {
              pageX = event.pageX;
            } else if (event.type === 'touchmove') {
              pageX = event.originalEvent.changedTouches[0].pageX;
            }
            currentMarker = parseInt(pageX / sectionWidth);
            if (currentMarker !== previousMarker) {
              $imagesList.eq(currentImage).toggle();
              if (currentMarker > previousMarker) {
                currentImage = currentImage + 1;
                if (currentImage >= imageCount) currentImage = 0;
              } else {
                currentImage = currentImage - 1;
                if (currentImage < 0) currentImage = imageCount - 1;
              }
              $imagesList.eq(currentImage).toggle();
              previousMarker = currentMarker;
            }
          }
        });
      });
      $element.on('mouseup.view360 touchend.view360', function () {
        Viewer.grab($imagesList);
        allowMove = false;
        $element.off('mousemove.view360 touchmove.view360');
      });

      // This line prevents browsers from trying to "text select"
      // the draggable object.
      $element.on('selectstart dragstart', function (e) {
        e.preventDefault();
        return false;
      });
    },
    grab: function (element) {
      element.css('cursor', 'url(/dkmobile/images/openhand.cur), move');
      element.css('cursor', '-webkit-grab');
      element.css('cursor', '-moz-grab');
    },
    grabbing: function (element) {
      element.css('cursor', 'url(/dkmobile/images/closedhand.cur), move');
      element.css('cursor', '-webkit-grabbing');
      element.css('cursor', '-moz-grabbing');
    }
  };
})(window.jQuery, window);
(function ($, window, undefined) {
  $.fn.modalMediaViewer = function (options) {
    return this.each(function (index, element) {
      let modalMediaViewer = Object.create(ModalMediaViewer);
      $.data(this, 'modalMediaViewer', modalMediaViewer);
      modalMediaViewer.init(options, element);
      return this;
    });
  };
  $.fn.modalMediaViewer.options = {
    currentThumbnailClass: 'mediaviewer__thumb-item--current',
    thumbnailSelector: '.pic--thumbnails > li > a',
    thumbnailIdSelectorPrefix: '#media-thumb-',
    modalMediaContainerId: '#primary-media-container',
    customerImgTab: '#customer-img-tab',
    customerImgContent: '#customer-imgs',
    productImgTab: '#product-img-tab',
    productImgContent: '#product-imgs',
    productImgContainer: '#product-media-display'
  };
  let ModalMediaViewer = {
    init: function (options, elem) {
      const self = this;
      self.options = $.extend({}, $.fn.modalMediaViewer.options, options);
      self.$parentModal = $(elem);
      self.$mediaDisplay = self.$parentModal.find('#product-media-display');
      self.modal = self.$parentModal[0];
      self.previousX = 0;
      self.previousY;
      self.scale = 1;
      let $parentModal = self.$parentModal,
        $mediaDisplay = self.$mediaDisplay;
      self.initEvents($parentModal, $mediaDisplay);
      if ($('#customer-media-0').length) {
        self.updateCaption($('#customer-media-0'));
      }
    },
    initEvents: function ($parentModal, $mediaDisplay) {
      self = this;
      $parentModal.find(self.options.thumbnailSelector).on('click', function (e) {
        e.preventDefault();
        self.selectThumbnail(e.currentTarget.parentElement);
        let newMediaId = $(e.currentTarget).data('mediaId');
        self.selectMedia(newMediaId);
        self.initModalZoom(newMediaId);
      });
      // only attach event listener to fist match, if any exists.
      $('#customer-imgs #carouselControls:first').each((i, elem) => elem.addEventListener('slide.bs.carousel', function (e) {
        self.updateCaption($(e.relatedTarget));
      }));
      $('.pimg__carousel-control').on('click', function (e) {
        self.enableProdImgArrows($(e.currentTarget));
      });
      self.enableModalSwipe(document.getElementById('product-media-display'));
    },
    enableModalSwipe: function (selector) {
      const hammer = new Hammer(selector);
      hammer.on('swipe', function (ev) {
        let currentImage = $('.product-media__swipe:visible'),
          currentImageParent = currentImage.parent(),
          nextImage = currentImageParent.next('.product-media__link').children(),
          prevImage = currentImageParent.prev('.product-media__link').children(),
          firstImage = currentImageParent.siblings('.product-media__link').first().children(),
          lastImage = currentImageParent.siblings('.product-media__link').last().children();
        let newMediaId;
        let imgCount = currentImageParent.siblings('.product-media__link').length;

        // Don't swipe if image is zoomed.
        // Only swipe if more than one image
        if (currentImage.attr('data-zoom') !== 'zoomed' && imgCount > 0) {
          if (ev.direction === Hammer.DIRECTION_RIGHT) {
            prevImage.length ? newMediaId = prevImage.data('media') : newMediaId = lastImage.data('media');
            /**
             * Needed to have the functions called within the
             * directional to avoid no media id if swiped down or up
             */
            self.selectMedia(newMediaId);
            self.initModalZoom(newMediaId);
          } else if (ev.direction === Hammer.DIRECTION_LEFT) {
            nextImage.length ? newMediaId = nextImage.data('media') : newMediaId = firstImage.data('media');
            self.selectMedia(newMediaId);
            self.initModalZoom(newMediaId);
          }
        }
      });
    },
    enableProdImgArrows: function (elem) {
      let currentImage = $('.product-media__swipe:visible'),
        currentImageParent = currentImage.parent(),
        nextImage = currentImageParent.next('.product-media__link').children(),
        prevImage = currentImageParent.prev('.product-media__link').children(),
        firstImage = currentImageParent.siblings('.product-media__link').first().children(),
        lastImage = currentImageParent.siblings('.product-media__link').last().children();
      let newMediaId;
      if (elem.hasClass('carousel-control-next')) {
        nextImage.length ? newMediaId = nextImage.data('media') : newMediaId = firstImage.data('media');
        self.selectMedia(newMediaId);
        self.initModalZoom(newMediaId);
      } else if (elem.hasClass('carousel-control-prev')) {
        prevImage.length ? newMediaId = prevImage.data('media') : newMediaId = lastImage.data('media');
        self.selectMedia(newMediaId);
        self.initModalZoom(newMediaId);
      }
    },
    selectThumbnail: function (newThumb) {
      const self = this;
      let $newThumb;
      if (typeof newThumb === 'number') {
        $newThumb = $(self.options.thumbnailIdSelectorPrefix + newThumb).parent();
      } else {
        $newThumb = $(newThumb);
      }
      $newThumb.siblings().removeClass(self.options.currentThumbnailClass);
      $newThumb.addClass(self.options.currentThumbnailClass);
      const newid = $newThumb.children().data('mediaId');
      let $newMedia = $(`#media-${newid}`);
      if ($newMedia.data('mediaType') === 'image') {
        $newMedia.pinchZoom().pinchZoom('reset');
      }
    },
    updateCaption: function ($target) {
      const self = this,
        mediaModal = self.$parentModal,
        captionContainer = mediaModal.find('.cpic__caption--dt h5'),
        caption = $target.data('description'),
        // Since TurnTo's customer images are fairly limited and won't allow us
        // to pull back images from all users for a given sku we append the
        // user's nickname to the text with a dash, "caption -NickName",
        // rather than submitting HTML to TurnTo we wrap the nickname here.
        newImageCaption = caption === null ? '' : caption.replace(/\s*(-\w+)$/, '<div class="cpic__cite">$1</div>');
      captionContainer.html(newImageCaption);
    },
    hideMedia: function (oldMedia) {
      const $oldMedia = $(oldMedia);
      const mediaType = $oldMedia.data('mediaType');
      if (mediaType === 'image') {
        const ezPlus = $oldMedia.find('img[data-zoom-image]').data('ezPlus');
        if (ezPlus) {
          ezPlus.destroy();
        }
      } else if (mediaType === 'video') {
        $oldMedia.find('iframe').removeAttr('src');
      } else if (mediaType === 'image360') {
        $oldMedia.off();
      }
      $oldMedia.hide();
    },
    hideAllMedia: function () {
      const self = this;
      self.$mediaDisplay.find('[data-media-type]').each(function (index, element) {
        self.hideMedia(element);
      });
    },
    selectMedia: function (newMediaId) {
      const self = this;
      let $newMedia = $(`#media-${newMediaId}`),
        $primaryMediaContainer = $('.mediaviewer__primary-media').children();
      mediaType = $newMedia.data('mediaType'), mediaUrl = $newMedia.data('mediaUrl'), $oldMedia = self.$mediaDisplay.find('a[id^=media-]').filter(function () {
        return $primaryMediaContainer.find(':visible');
      });
      self.hideMedia($oldMedia);
      $newMedia.show();
    },
    initModalZoom: function (newMediaId) {
      let $newMedia = $(`#media-${newMediaId}`),
        mediaUrl = $newMedia.data('mediaUrl'),
        mediaType = $newMedia.data('mediaType');
      if (mediaType === 'video') {
        $newMedia.find('iframe').attr('src', mediaUrl);
      } else if (mediaType === 'image') {
        $newMedia.pinchZoom();
      } else if (mediaType === 'image360') {
        $newMedia.view360();
      }
    }
  };
})(window.jQuery, window);
// MediaViewer refers to the page's media, thumbnails & swatches
// ModalMediaViewer refers to the modal after clicking on a prod image.
'use strict';

(function ($, window, undefined) {
  $.fn.mediaViewer = function (options) {
    return this.each(function (index, element) {
      let mediaViewer = Object.create(MediaViewer);
      mediaViewer.init(options, element);
      $.data(this, 'mediaViewer', mediaViewer);
      return this;
    });
  };
  $.fn.mediaViewer.options = {
    thumbnailSelector: '.mediaviewer__thumb-carousel .js-popup-link',
    thumbnailCarouselSelector: '.mediaviewer__thumb-carousel',
    zoomContainerSelector: '#primary-media-section .mediaviewer__primary-link',
    currentThumbnailClass: 'mediaviewer__thumb-item--current',
    mediaModalId: '#media-viewer-modal',
    mediaContainerId: '#primary-media-container',
    mediaType: '.mediaviewer [data-media-src]',
    onInitEvent: 'function() {}',
    isOpenBox: false
  };
  let MediaViewer = {
    init: function (options, elem) {
      let self = this;
      self.options = $.extend({}, $.fn.mediaViewer.options, options);
      self.elem = elem;
      self.$elem = $(elem);
      self.$thumbnailSelector = $(self.options.thumbnailSelector);
      self.$thumbnailCarousel = $(self.options.thumbnailCarouselSelector);
      self.$zoomContainer = $(self.options.zoomContainerSelector);
      self.zoomPlugin = null;
      self.initThumbnails(self.$thumbnailSelector);
      self.initSwatches($('.attr__swatch div'));
      if (document.readyState === 'complete') {
        self.initImageZoom(self.$zoomContainer.find('img:first').parent('a:first'), window);
      } else {
        window.addEventListener('load', function () {
          self.initImageZoom(self.$zoomContainer.find('img:first').parent('a:first'), window);
        }, false);
      }
      self.enableTouchSwipe(self.elem);
      self.carousel = new Carousel(self.$thumbnailCarousel);
      self.carousel._init();
      $(self.options.mediaModalId)[0].addEventListener('hidden.bs.modal', function (e) {
        $(e.currentTarget).data('modalMediaViewer').hideAllMedia();
        self.initImageZoom(self.$zoomContainer.find('img:first').parent('a:first'), window);
      });
      $('.mediaviewer .js-customer-media').on('click', function (e) {
        e.preventDefault();
        let target = $(e.currentTarget);
        let dataType = target.data('mediaType');
        let newMediaId = $('.js-zoom-image:visible').data('mediaId');
        self.openMediaModal(target, newMediaId, dataType);
      });
      $('.ob-item__imgs a').off('click');
      $('.ob-item__imgs a').on('click', function (e) {
        e.preventDefault();
        self.options.isOpenBox = true;
        let target = $(e.currentTarget);
        let newMediaId = $(this).data('mediaId');
        self.resetModal();
        self.openOpenBoxModal(target, newMediaId);
      });
      $('.ob.offcanvas')[0].addEventListener('hide.bs.offcanvas', event => {
        self.resetModal();
      });
    },
    initThumbnails: function ($thumbnailSelector) {
      let self = this;
      $thumbnailSelector.on('click', function (e) {
        e.preventDefault();
        self.changeCurrentThumbnail(e.currentTarget.parentElement);
        let mediaId = $(e.currentTarget).data('mediaId');
        let images = $(self.options.zoomContainerSelector);
        let currentPrimaryImage = images.find('img:visible').parent('a');
        let newPrimaryImage = images.find(`img[data-media-id="${mediaId}"]`).parent('a');
        self.changePrimaryImage(currentPrimaryImage, newPrimaryImage);
        self.initSwatches($('.attr__swatch div'));
      });
    },
    initSwatches: function ($imageSwatchSelector) {
      let timer,
        delay = 100,
        primaryImageSelector = $('.mediaviewer__primary-link:visible img'),
        primaryImage = primaryImageSelector.attr('src'),
        differingAttributeSelector = $('#selection'),
        productDifferingAttribute = $('.attr__swatch .selected').data('productDifferingAttribute');
      $imageSwatchSelector.on('mouseenter mouseleave', function (e) {
        // on mouse in, start a timeout
        timer = setTimeout(function () {
          const swatch = $(e.currentTarget),
            productImage = swatch.find('img').data('mediaUrl'),
            differingAttribute = swatch.data('productDifferingAttribute');

          // replace the primary image with the thumbnail image
          primaryImageSelector.attr('src', productImage);
          // replace the differing attribute name with the swatches attribute
          differingAttributeSelector.text(differingAttribute);
        }, delay);
      }, function () {
        // on mouse out, cancel the timer and reset the primary image and differing attribute name
        clearTimeout(timer);
        primaryImageSelector.attr('src', primaryImage);
        differingAttributeSelector.text(productDifferingAttribute);
      });
    },
    initImageZoom: function ($zoomContainer, window) {
      const self = this;
      let count;
      // Prevent accumulating event handlers
      $zoomContainer.off('click');
      $zoomContainer.on('click tap', function (e) {
        e.preventDefault();
        const target = $(e.currentTarget);
        const newMediaId = target.data('mediaId');
        /* Count = Inelegant way to prevent double click on image,
        double click caused the this event to fire twice and
        load all the images catawampus */
        if (count != '1') {
          self.openMediaModal(target, newMediaId, null);
          count = '1';
        }
        setTimeout(function () {
          count = '0';
        }, 500);
      });
      self.enableZoom($zoomContainer);

      // Resets the ElevateZoom plugin when the screen sizes. The
      // plugin is semi-responsive in that it reads the configuration
      // once and then changes settings appropriately, but it does not
      // track window resizes by itself.
      $(window).on('resize', function () {
        if (this.resizeTO) clearTimeout(this.resizeTO);
        this.resizeTO = setTimeout(function () {
          $(this).trigger('resizeEnd');
        }, 250);
      });
      $(window).on('resizeEnd', function () {
        const imageContainer = self.$zoomContainer.find(':visible').parent('a');
        self.disableZoom(imageContainer);
        self.enableZoom(imageContainer);
      });
    },
    openMediaModal: function (target, newMediaId, dataType) {
      let self = this;

      // The data-media-url attribute can be used to override the
      // href attribute. This is useful to allow non-javascript users
      // to go to another location as a fallback.
      let dataUrl = $(target).data('mediaUrl') || target.href;
      let mediaViewerModal = $(self.options.mediaModalId),
        isModalLoaded = mediaViewerModal.data('modalLoaded');
      if (isModalLoaded === true) {
        let customerImageTab = $('#customer-img-tab'),
          productImageTab = $('#product-img-tab');
        // Modal was previously loaded via ajax. No need to request
        // data again.
        mediaViewerModal[0].addEventListener('show.bs.modal', function () {
          const $mediamodal = mediaViewerModal.data('modalMediaViewer');
          $mediamodal.initModalZoom(newMediaId);
          if (self.options.isOpenBox !== true) {
            $mediamodal.selectThumbnail(newMediaId);
          }
          dataType === null || dataType === 'openbox' ? productImageTab.tab('show') : customerImageTab.tab('show');
          mediaViewerModal.data('modalMediaViewer').selectMedia(newMediaId);
        });
        bootstrap.Modal.getOrCreateInstance(mediaViewerModal[0]).show();
        return;
      }
      $.ajax({
        url: dataUrl
      }).done(function (data) {
        // Replace the media modal contents with new HTML
        mediaViewerModal.find('.modal-content').html(data);
        mediaViewerModal[0].addEventListener('show.bs.modal', () => {
          let customerImageTab = $('#customer-img-tab'),
            customerMedia = $('.cpic__carousel-inner').children('.active').data('description'),
            productImageTab = $('#product-img-tab');
          dataType === null || dataType === 'openbox' ? bootstrap.Tab.getOrCreateInstance(productImageTab[0]).show() : bootstrap.Tab.getOrCreateInstance(customerImageTab[0]).show();
          if (customerImageTab.hasClass('active')) {
            $('#customer-imgs').find('.cpic__caption--dt h5').text(customerMedia);
          }
          mediaViewerModal.modalMediaViewer();
          mediaViewerModal.data('modalMediaViewer').selectMedia(newMediaId);
        }, {
          once: true
        });
        mediaViewerModal[0].addEventListener('shown.bs.modal', function () {
          mediaViewerModal.off('shown.bs.modal');
          let $mediamodal = mediaViewerModal.data('modalMediaViewer');
          $mediamodal.initModalZoom(newMediaId);
          mediaViewerModal.data('modalLoaded', true);
        });
        bootstrap.Modal.getOrCreateInstance(mediaViewerModal[0]).show();
      });
    },
    openOpenBoxModal: function (target, newMediaId) {
      let self = this;

      // The data-media-url attribute can be used to override the
      // href attribute. This is useful to allow non-javascript users
      // to go to another location as a fallback.
      let dataUrl = $(target).data('mediaUrl') || target.href;
      let mediaViewerModal = $(self.options.mediaModalId),
        isModalLoaded = mediaViewerModal.data('modalLoaded');
      if (isModalLoaded === true) {
        // Modal was previously loaded via ajax. No need to request
        // data again.
        mediaViewerModal[0].addEventListener('show.bs.modal', () => {
          const $mediamodal = mediaViewerModal.data('modalMediaViewer'),
            $newMedia = $(`#media-${newMediaId}`);
          $mediamodal.initModalZoom(newMediaId);
          $('#product-img-tab').tab('show');
          mediaViewerModal.data('modalMediaViewer').selectMedia(newMediaId);
          $newMedia.pinchZoom().pinchZoom('reset');
        });
        bootstrap.Modal.getOrCreateInstance(mediaViewerModal[0]).show();
        return;
      }
      $.ajax({
        url: dataUrl
      }).done(function (data) {
        // Replace the media modal contents with new HTML
        mediaViewerModal.find('.modal-content').html(data);
        mediaViewerModal[0].addEventListener('show.bs.modal', () => {
          let productImageTab = $('#product-img-tab');
          bootstrap.Tab.getOrCreateInstance(productImageTab[0]).show();
          productImageTab.parent().siblings().hide();
          mediaViewerModal.modalMediaViewer();
          mediaViewerModal.data('modalMediaViewer').selectMedia(newMediaId);
        }, {
          once: true
        });
        mediaViewerModal[0].addEventListener('shown.bs.modal', () => {
          mediaViewerModal.off('shown.bs.modal');
          let $mediamodal = mediaViewerModal.data('modalMediaViewer');
          $mediamodal.initModalZoom(newMediaId);
          mediaViewerModal.data('modalLoaded', true);
        });
        bootstrap.Modal.getOrCreateInstance(mediaViewerModal[0]).show();
      });
    },
    /**
     * Sets the media modal to be refreshed next time it is opened.
     */
    resetModal: function () {
      let self = this;
      let $mediaViewerModal = $(self.options.mediaModalId);
      $mediaViewerModal.data('modalLoaded', false);
    },
    changeCurrentThumbnail: function (target) {
      const self = this;
      const $newThumb = $(target);
      $newThumb.siblings().removeClass(self.options.currentThumbnailClass);
      $newThumb.addClass(self.options.currentThumbnailClass);
    },
    changePrimaryImage: function (oldImage, newImage) {
      const self = this;
      const spinner = new Spinner();
      const image = newImage.find('img');
      const imgNum = newImage.data('num'),
        imgTotal = $('.mediaviewer__primary-media a.mediaviewer__primary-link').length,
        $imgCap = $('div.fig-bg__cap');
      if (!newImage.length) {
        return;
      }

      // Added for mobile figure caption # of images//
      $imgCap.text(`${imgNum} / ${imgTotal}`);
      // Disable zoom first. This is the safest way to make sure the
      // ezPlus plugin can remove the correct instance and not get confused
      self.disableZoom(oldImage);
      oldImage.hide();
      newImage.fadeIn();
      if (image.attr('src').startsWith('data:image')) {
        spinner.spin(newImage[0]);
        image.on('load', function () {
          $(this).hide().fadeIn();
          spinner.stop();
        });
        image.attr('src', image.data('original'));
      } else {
        image.fadeIn();
      }
      // Enable zoom once the primary image attributes have been updated
      self.initImageZoom(newImage, window);
    },
    enableZoom: function ($zoomContainer) {
      if ($zoomContainer.data('mediaType') !== 'image') {
        return;
      }
      const zoomImage = $zoomContainer.find('img');
      zoomImage.ezPlus({
        borderSize: 1,
        cursor: 'crosshair',
        zIndex: 1,
        respond: [{
          range: '100-991',
          zoomEnabled: false,
          enabled: false // Disable on mobile to prevent touch scroll problems
        }, {
          range: '992-1299',
          zoomEnabled: true,
          zoomWindowHeight: 400,
          zoomWindowWidth: 400
        }, {
          range: '1300-99999',
          zoomEnabled: true,
          zoomWindowHeight: 550,
          zoomWindowWidth: 550
        }]
      });
    },
    disableZoom: function ($zoomContainer) {
      const ezPlus = $zoomContainer.find('img').data('ezPlus');
      if (ezPlus && ezPlus.options.enabled) {
        ezPlus.destroy();
      }
    },
    /**
     * Enable swiping on the primary image to go to the next/previous image
     * @param {HTMLElement} swipeContainer The container holding the
     *        images that swiping motions should be detected on
     */
    enableTouchSwipe: function (swipeContainer) {
      const self = this;
      let hammertime = new Hammer(swipeContainer);
      hammertime.on('swipe', function (ev) {
        const $target = $(ev.target).parents('a');
        const $nextElement = $target.next(),
          $prevElement = $target.prev(),
          $firstElement = $target.siblings(':first'),
          $lastElement = $target.siblings(':last');
        let $image, $newThumbnail;
        if (ev.direction === Hammer.DIRECTION_RIGHT) {
          if ($prevElement.length) {
            self.changePrimaryImage($target, $prevElement);
            $image = $prevElement.find('img');
          } else {
            self.changePrimaryImage($target, $lastElement);
            $image = $lastElement.find('img');
          }
          $newThumbnail = $(`.mediaviewer__thumb-wrapper a[data-media-id=
								${$image.data('mediaId')}]`).parent();
          self.changeCurrentThumbnail($newThumbnail);
          self.carousel.scrollTo($newThumbnail);
        } else if (ev.direction === Hammer.DIRECTION_LEFT) {
          if ($nextElement.length) {
            self.changePrimaryImage($target, $nextElement);
            $image = $nextElement.find('img');
          } else {
            self.changePrimaryImage($target, $firstElement);
            $image = $firstElement.find('img');
          }
          $newThumbnail = $(`.mediaviewer__thumb-wrapper a[data-media-id=
							${$image.data('mediaId')}]`).parent();
          self.changeCurrentThumbnail($newThumbnail);
          self.carousel.scrollTo($newThumbnail);
        }
      });
    }
  };

  /**
   * Creates a carousel for the thumbnails
   * @constructor
   * @param {jQuery} $carousel - The parent element containing the thumbnails
   */
  function Carousel($carousel) {
    this.$carousel = $carousel;
    this.thumbnailHeight = this.$carousel.find('li:first').find('a').outerHeight(true);
    this.options = {
      arrowUp: `<a class="control control-prev" href="#" style="display:none">
				<span class="dk dk-chevron-up-500" aria-hidden="true"></span>
				<span class="visually-hidden">Previous</span></a>`,
      arrowDown: `<a class="control control-next" href="#" style="display:none">
				<span class="dk dk-chevron-down-500" aria-hidden="true"></span>
				<span class="visually-hidden">Next</span></a>`
    };
  }

  /**
   * Initializes the carousel events.
   * @private
   */
  Carousel.prototype._init = function () {
    let self = this;
    self.displayArrows();
    self.addMouseWheelSupport();
    window.addEventListener('resize', function () {
      self.displayArrows();
    });
  };

  /**
   * Displays the previous/next arrows should be shown, if required. Event
   * handlers will be added to the arrows once they are added to the page
   * to enable scrolling.
   * Arrows will only be displayed when the carousel has more content than
   * the carousel's container will allow displayed.
   **/
  Carousel.prototype.displayArrows = function () {
    let $carousel = this.$carousel,
      clientHeight = $carousel[0].clientHeight,
      scrollHeight = $carousel[0].scrollHeight,
      $controls = $carousel.siblings('.control');
    if (scrollHeight > clientHeight) {
      if ($controls.length === 0) {
        $(this.options.arrowUp).insertBefore($carousel);
        $(this.options.arrowDown).insertAfter($carousel);

        // Refresh the control selector after they are added
        $controls = $carousel.siblings('.control');
        this.addArrowEventHandlers($controls);
      }
      $controls.show();
      $carousel.css({
        'margin-top': '1.5rem',
        'margin-bottom': '1.5rem'
      });
    } else {
      $controls.hide();
      $carousel.css({
        'margin-top': '0',
        'margin-bottom': '0'
      });
    }
  };

  /**
   * Scroll to the given thumbnail
   * @param {jQuery} newThumbnail - The thumbnail to scroll to
   **/
  Carousel.prototype.scrollTo = function (newThumbnail) {
    const thumbnailHeight = this.$carousel.find('li:first').find('a').outerHeight(true);
    let index = this.$carousel.find('li').index(newThumbnail);
    this.$carousel.stop().animate({
      scrollTop: thumbnailHeight * index
    }, 200, 'swing');
  };
  Carousel.prototype.scrollUp = function (scrollAmount) {
    // Scroll by a negative number to move to the previous element
    this.scroll(-Math.abs(scrollAmount));
  };
  Carousel.prototype.scrollDown = function (scrollAmount) {
    // Scroll by a positive number to move to the next element
    this.scroll(Math.abs(scrollAmount));
  };

  /**
   * Scrolls the carousel by the given amount. A negative number
   * will cause the carousel to scroll backwards.
   * @param {Number} scrollAmount - The number of pixels to scroll the
   *        carousel by. Positive numbers advance the carousel,
   *        negative numbers reverse the carousel.
   **/
  Carousel.prototype.scroll = function (scrollAmount) {
    if (scrollAmount === undefined || scrollAmount === null) {
      console.log('Unknown scroll amount - no scrolling will be performed');
      return;
    }

    // Scroll forward when scrollAmount is positive and scroll backwards
    // when scrollAmount is negative
    this.$carousel.finish().animate({
      scrollTop: this.$carousel[0].scrollTop + scrollAmount
    }, 200, 'swing');
  };
  Carousel.prototype.addArrowEventHandlers = function ($controls) {
    let intervalId = null,
      self = this,
      scrollAmount = this.$carousel.find('li:first').find('a').outerHeight(true);
    $controls.filter('.control-prev').on('click touchstart', function (e) {
      e.preventDefault();
      self.scrollUp(scrollAmount);
    }).on('mousedown touchstart', function (e) {
      intervalId = setInterval(function () {
        self.scrollUp(scrollAmount);
      }, 200);
    }).on('mouseup mouseout touchend', function (e) {
      clearInterval(intervalId);
    });
    $controls.filter('.control-next').on('click touchstart', function (e) {
      e.preventDefault();
      self.scrollDown(scrollAmount);
    }).on('mousedown touchstart', function (e) {
      intervalId = setInterval(function () {
        self.scrollDown(scrollAmount);
      }, 200);
    }).on('mouseup mouseout touchend', function (e) {
      clearInterval(intervalId);
    });
  };

  /**
   * Adds event handlers to allow mouse wheel scrolling on the carousel.
   * This is meant to handle vertical scrolling support only, not
   * horizontal scrolling. Nobody expects to use the mouse wheel to scroll
   * horizontally (right? right?).
   **/
  Carousel.prototype.addMouseWheelSupport = function () {
    const self = this;
    self.$carousel.on('wheel', function (e) {
      e.preventDefault();
      let event = e.originalEvent;
      let scrollAmount;
      if (event.deltaMode === WheelEvent.DOM_DELTA_PIXEL) {
        // Handle IE and Chrome or any other sane browser
        scrollAmount = event.deltaY;
      } else if (event.deltaMode === WheelEvent.DOM_DELTA_LINE) {
        // Handle Firefox when it sends the delta as lines
        scrollAmount = event.deltaY * 16;
      } else {
        // Treat WheelEvent.DOM_DELTA_PAGE as a single thumbnail.
        // This should only be triggered when a Windows user
        // configures their mouse scrolling properties to scroll by
        // page instead of line
        scrollAmount = self.$carousel.find('li:first').find('a').outerHeight(true);
      }
      self.scroll(scrollAmount);
    });
  };
})(window.jQuery, window);
$(function () {
  $('#primary-media-section .pic').mediaViewer();

  // Mobile show arrows if the is more than one image and the breakpoint is less than lg
  $(window).on('lessThan-lg', function () {
    let $target = $('.mediaviewer__primary-media a'),
      directionArrows = $('[data-direction]');
    if ($target.length > 1) {
      directionArrows.show();
    }
  });
});

// Configure the left and right arrows on mobile if there is more than one img.
// Images will loop in either direction
// Cannot be touchstart or will fire twice
$(document).on('click touchend', '.next, .prev', function (e) {
  e.preventDefault();
  e.stopPropagation();
  const $target = $('.mediaviewer__primary-media a:visible');
  const direction = $(e.currentTarget).data('direction');
  const $mediaViewer = $target.parents('.mediaviewer.pic.row').data('mediaViewer');
  const $nextElement = $target.next(),
    $prevElement = $target.prev(),
    $firstElement = $target.siblings(':first'),
    $lastElement = $target.siblings(':last');
  if (direction === 'next') {
    if ($nextElement.length) {
      $mediaViewer.changePrimaryImage($target, $nextElement);
    } else {
      $mediaViewer.changePrimaryImage($target, $firstElement);
    }
  } else if (direction === 'prev') {
    if ($prevElement.length) {
      $mediaViewer.changePrimaryImage($target, $prevElement);
    } else {
      $mediaViewer.changePrimaryImage($target, $lastElement);
    }
  }
});
var DK = DK || {};
DK.product = DK.product || {};
DK.product.skuInfo = {
  // Initialize the event handlers for the differing attribute selector
  // and the product selector
  init: function () {
    DK.product.skuInfo.setInitialHistoryPage();
    DK.product.skuInfo.initHistoryEventHandlers();
    DK.product.skuInfo.initGiftListButton();
  },
  setInitialHistoryPage: function () {
    let historyData = {
      skuId: $('#sku-id-param').val() || null,
      productId: $('#prd-id-param').val() || null,
      url: document.location + '',
      title: document.title
    };
    window.history.replaceState({
      content: historyData
    }, historyData.title, historyData.url);
  },
  initHistoryEventHandlers: function () {
    $(document).on('change', '#change-attr', function (e) {
      let option = e.currentTarget.options[e.currentTarget.selectedIndex],
        $option = $(option);
      let skuId = $option.data('skuId'),
        productId = $option.data('productId'),
        style = $option.data('style');
      DK.product.skuInfo.updateContent(skuId, productId, style).done(DK.product.skuInfo.updatePageHistory);
      window.dataLayer.push({
        event: 'selectionMade',
        selectedElement: skuId
      });
    });
    $(document).on('click', '#attribute-swatches [data-product-id]:not([disabled])', function (e) {
      e.preventDefault();
      let selected = $(e.currentTarget),
        productId = selected.data('productId'),
        style = selected.data('style'),
        deselected = selected.siblings();

      // Update the selected product letiation before AJAX fires so
      // the user can have more indicators of what they selected
      selected.addClass('selected');
      deselected.removeClass('selected');
      DK.product.skuInfo.updateContent(null, productId, style).done(DK.product.skuInfo.updatePageHistory);
    });
  },
  initGiftListButton: function () {
    $('.giftlist-modal-btn').on('click', function (e) {
      const $currentTarget = $(e.currentTarget);
      let items = $('#add-to-cart-form').find('input[name^=skuId]').map(function (i, input) {
        let prefix = input.id.substring(0, input.id.indexOf('skuId')),
          differentiator = $(input).data('glPosition'),
          skuId = $(`#${prefix}skuId`).val(),
          price = $(`#${prefix}current-price`).val(),
          quantity,
          quantitySelector;
        if (differentiator) {
          quantitySelector = `[data-gl-quantity='${differentiator}']:visible`;
        } else {
          quantitySelector = '[data-gl-quantity]:visible';
        }
        quantity = $(quantitySelector).length !== 0 ? Number($(quantitySelector).val().trim()) : 1;
        return {
          skuId: skuId,
          price: price,
          quantity: quantity
        };
      }).get();
      $currentTarget.data('gl', JSON.stringify(items));
    });
  },
  updateRecentlyViewedCookie: function (skuId, parentId) {
    if (parentId != null && skuId != null) {
      recentItemData = Cookies.get('recent_items');
      splitRecentItemData = [1, null];
      if (recentItemData != null) {
        splitRecentItemData = recentItemData.split('|');
      }
      if (splitRecentItemData.length === 2) {
        recentProducts = [];
        if (splitRecentItemData[1] != null) {
          recentProducts = splitRecentItemData[1].split('_');
        }
        recentProductsMap = new Map();
        for (i = 0; i < recentProducts.length; i++) {
          recentProduct = recentProducts[i];
          recentProductSplit = recentProduct.split(':');
          if (recentProductSplit.length === 2) {
            recentProductsMap.set(recentProductSplit[0], recentProductSplit[1]);
          }
        }
        if (recentProductsMap.has(parentId)) {
          recentProductsMap.delete(parentId);
        }
        recentProductsMap.set(parentId, skuId);
        updatedRecentProducts = [];
        for (const [key, val] of recentProductsMap) {
          updatedRecentProducts.push(`${key}:${val}`);
        }
        if (recentProducts.length > 8) {
          updatedRecentProducts.shift();
        }
        Cookies.set('recent_items', `${splitRecentItemData[0]}|${updatedRecentProducts.join('_')}`);
      }
    }
  },
  updateContent: function (skuId, productId, style) {
    let spinner = new Spinner();
    const $primaryMedia = $('#primary-media-section');
    const $skuInfo = $('.sku-info-section');
    const $productDetails = $('#tab-section');
    const $spinnerContainer = $('#sku-info-ajax-blocker');
    const $recommendationContent = $('.product-recommendations');
    const $openBox = $('#open-box-section');
    const productFamilyId = $('#prd-fam-id-param').val();
    return $.ajax({
      url: '/product/sku',
      data: {
        skuId: skuId,
        productId: productId,
        style: style
      },
      beforeSend: function () {
        DK.displayBlocker($spinnerContainer);
        spinner.spin($spinnerContainer.get()[0]);
      },
      complete: function () {
        DK.hideBlocker($spinnerContainer);
        spinner.stop();
      }
    }).done(function (data) {
      $primaryMedia.find('.pic').replaceWith(data.productMediaHtml);
      //Reinitialize mobile image carousel arrows
      $(window).breakpoints('lessThan', 'lg', function () {
        let $target = $('#primary-media-container a'),
          directionArrows = $('[data-direction]');
        if ($target.length > 1) {
          directionArrows.show();
        }
      });
      Cookies.set('product_family_sku', data.skuId, {
        expires: 1,
        secure: true
      });

      // Sku id is null when switching between products on a family page
      if (!skuId) {
        skuId = data.skuId;
      }
      DK.product.skuInfo.updateRecentlyViewedCookie(skuId, productFamilyId);
      $skuInfo.html(data.productInfoHtml);

      // TurnTo holds references to the elements it rendered into (and
      // may replace its placeholder divs), so move the rendered contents
      // of each widget wrapper into the new tab markup rather than
      // letting them be replaced.
      const turnToWidgets = {};
      $productDetails.find('[data-turnto-widget]').each(function (i, wrapper) {
        turnToWidgets[wrapper.dataset.turntoWidget] = $(wrapper).contents().detach();
      });
      $productDetails.html(data.productTabsHtml);
      $productDetails.find('[data-turnto-widget]').each(function (i, wrapper) {
        const $contents = turnToWidgets[wrapper.dataset.turntoWidget];
        if ($contents) {
          $(wrapper).empty().append($contents);
        }
      });
      $openBox.html(data.openBoxHtml);

      // Re-render the TurnTo widgets if the product changed
      if (DK.TurnTo && DK.TurnTo.instance) {
        DK.TurnTo.instance.refresh(data.ttProductId);
      }
      if (data.recommendationsHtml) {
        $recommendationContent.html(data.recommendationsHtml);
        DK.Recommendations.initCarousel($('[data-rec-container]'));
      }
      if (window.affirm && window.affirm.ui && typeof window.affirm.ui.refresh === 'function') {
        affirm.ui.refresh();
      }

      // Reinitialize the add to cart modal
      DK.AddToCart.init('#add-to-cart-form');

      // Reinitialize the shipping timer under the Add to Cart form
      let shippingTimer = $('#shipping-timer-header [data-shipping-timer]').data('shippingTimer');
      if (shippingTimer) {
        let existingHeaderTimer = shippingTimer.countdownTimer;
        $('#shipping-timer-slot [data-shipping-timer]').shippingTimer({}, existingHeaderTimer);
      }

      // Reinitialize the product media viewer. Waits for the primary
      // image to load in order to accurately size the container.
      $('#primary-media-section').find('img').one('load', function () {
        let $mediaViewer = $('#primary-media-section .pic').mediaViewer();
        $mediaViewer.data('mediaViewer').resetModal();
      });

      // Reinitialize the gift list selector
      $('#gift-list-modal').giftList();
      DK.loginHandler('#add-to-gift-list [data-login]', '#login-modal');
      DK.product.skuInfo.initGiftListButton();

      //Updated create new list with new sku id
      $('#gift-list-modal-form a.js-hook').each(function (index, element) {
        let url = element.getAttribute('href'),
          updatedUrl = DK.queryStringUrlReplacement(url, 'skuIds', data.skuId);
        element.setAttribute('href', updatedUrl);
      });

      // Reinitialize the fitment tab selector
      $('#fitment .tab-content').fitmentSelector();

      // Reinitialize the quantity selector
      $('.qty--select').quantityPlus();

      //reinitialize popover for disabled cart
      $('[data-bs-toggle="popover"]').popover();

      //Enable Tooltip styles
      $('[data-bs-toggle="tooltip"]').tooltip();

      // Reinitalize the 'Email me when in stock' form
      DK.product.stockEmail.init();

      // Update breadcrumb
      $('.breadcrumb-item.active > span').text(data.breadcrumb);

      // Update the send to friend modal link
      const $sendToFriendLink = $('#send-to-friend'),
        baseSendToFriendUrl = $sendToFriendLink.attr('href').replace(/([^?]*).*/, '$1');
      let sendToFriendParam = `?productFamilyId=${productFamilyId}`;
      if (productId && productId != '') {
        sendToFriendParam = `?productId=${productId}`;
      }
      if (skuId && skuId != '') {
        sendToFriendParam = `?skuId=${skuId}`;
      }
      $sendToFriendLink.attr('href', baseSendToFriendUrl + sendToFriendParam);
    });
  },
  updatePageHistory: function (data) {
    document.title = data.title;
    let historyData = {
      skuId: data.skuId,
      productId: data.productId,
      url: data.url,
      title: data.title
    };
    history.replaceState({
      content: historyData
    }, data.title, data.url);
  }
};
DK.product.stockEmail = {
  init: function () {
    $('.inv__stock-email-wrapper form').on('submit', function (e) {
      e.preventDefault();
      const sku = $(this).find('.stock-skuid').val();
      const emailAddr = $(this).find('#inv__oos--input').val();
      DK.product.stockEmail.emailWhenInStock(sku, emailAddr);
    });
  },
  emailWhenInStock: function (sku, emailAddr) {
    let spinner = new Spinner(),
      $form = $(`.inv__stock-email-wrapper form.stock-email-form-${sku}`);
    $.ajax({
      type: 'POST',
      async: true,
      url: `/product/email/${sku}.json`,
      contentType: 'application/json; charset=utf-8',
      data: JSON.stringify({
        email: emailAddr,
        skuId: sku
      }),
      dataType: 'json',
      context: this,
      beforeSend: function () {
        DK.displayBlocker($form);
        spinner.spin($form.get()[0]);
      },
      complete: function () {
        DK.hideBlocker($form);
        spinner.stop();
      }
    }).done(function (data) {
      this.displayStockMessage(data, sku);
    });
  },
  displayStockMessage: function (data, sku) {
    const message = data.statusMessage;
    const messageClass = data.status;
    const wrapperDiv = $(`#stock-email-form-${sku}`).closest('.inv__stock-email-wrapper');
    wrapperDiv.off();
    wrapperDiv.remove('form');
    wrapperDiv.addClass(messageClass);
    wrapperDiv.addClass('inline-message alert');
    wrapperDiv.text(message);
  }
};
$(function () {
  DK.product.skuInfo.init();
  DK.product.stockEmail.init();
  DK.Recommendations.initCarousel($('[data-rec-container]'));
});
(function ($, window, undefined) {
  window.DK = DK || {};
  window.DK.QuantityPlus = QuantityPlus;
  $.fn.quantityPlus = function (options) {
    return this.each(function (index, element) {
      let quantityPlus = new QuantityPlus(element);
      $.data(this, 'quantityPlus', quantityPlus);
      $(element).on('change', function (e) {
        let target = e.currentTarget;
        if (target.tagName === 'SELECT' && target.value === 'qtyPlus') {
          quantityPlus.changeToInput();
        }
      });
      return this;
    });
  };
  function QuantityPlus(quantityEl) {
    this.element = quantityEl;
    this.originalElement = quantityEl;
  }
  QuantityPlus.prototype.changeToInput = function () {
    if (this.element.tagName === 'INPUT') {
      return;
    }
    let input = document.createElement('input');
    input.setAttribute('type', 'number');
    input.setAttribute('name', this.originalElement.getAttribute('name'));
    input.setAttribute('data-gl-quantity', this.originalElement.getAttribute('name'));
    input.setAttribute('class', 'form-control qtyPlusInput');
    input.setAttribute('max', '999');
    input.setAttribute('min', '0');
    input.setAttribute('autofocus', '');
    input.setAttribute('required', this.originalElement.getAttribute('required'));
    this.element.parentNode.replaceChild(input, this.element);
    this.element = input;
  };
  QuantityPlus.prototype.reset = function () {
    this.element.parentNode.replaceChild(this.originalElement, this.element);
    this.element = this.originalElement;
  };
})(window.jQuery, window);
$(function () {
  $('.qty--select').quantityPlus();
});
var DK = DK || {};
DK.socialMedia = DK.socialMedia || {};
DK.socialMedia = {
  init: function () {
    //Facebook
    (function () {
      let po = document.createElement('script');
      po.type = 'text/javascript';
      po.async = true;
      po.defer = true;
      po.src = '//connect.facebook.net/en_US/sdk.js#xfbml=1&appId=682407485432555&version=v2.11';
      po.id = 'facebook-jssdk';
      let s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(po, s);
    })();

    //Twitter
    (function () {
      let po = document.createElement('script');
      po.type = 'text/javascript';
      po.async = true;
      po.defer = true;
      po.src = 'https://platform.twitter.com/widgets.js';
      po.id = 'twitter-wjs';
      let s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(po, s);
    })();

    //Google Plus
    (function () {
      let po = document.createElement('script');
      po.type = 'text/javascript';
      po.async = true;
      po.src = 'https://apis.google.com/js/plusone.js?onload=onLoadCallback';
      let s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(po, s);
    })();

    //Pinterest
    (function () {
      let po = document.createElement('script');
      po.type = 'text/javascript';
      po.async = true;
      po.defer = true;
      po.src = 'https://assets.pinterest.com/js/pinit.js';
      let s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(po, s);
    })();
    $('a.facebook-bg').on('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      FB.ui({
        method: 'share',
        href: $('link[rel="canonical"]').attr('href')
      }, function (response) {});
    });
  }
};

//Copy url to clipboard function
function copyUrl() {
  let copyUrl = window.location.href;
  navigator.clipboard.writeText(copyUrl).then(() => {
    const popover = bootstrap.Popover.getInstance('#copy-url');
    setTimeout(function () {
      popover.hide();
    }, 2000);
  });
}
$(document).on('submit', '#send-to-friend-form', function (e) {
  e.preventDefault();
  const $form = $(this),
    spinner = new Spinner(),
    $modal = $form.parents('.modal'),
    $content = $modal.find('.modal-body-content');
  if ($content.length === 0) {
    // .modal-content will be empty on the standalone gift card
    // page. Target the form's parent element for the AJAX
    // spinner when the form is not in a modal.
    $content = $form.parent();
  }
  $.ajax({
    data: $form.serialize(),
    url: $form.attr('action'),
    method: $form.attr('method'),
    beforeSend: function () {
      DK.displayBlocker($content);
      spinner.spin($content.get()[0]);
    },
    complete: function () {
      DK.hideBlocker($content);
      spinner.stop();
    }
  }).done(function (data, textStatus, jqXHR) {
    $content.html(data);
  }).fail(function (jqXHR) {
    $form.html(jqXHR.responseText);
  });
});
$('.social-share-links').on('click', function () {
  DK.socialMedia.init();
});
$(function () {
  //WHen you click on reviews/write review or questions, bootstrap
  // opens the tab and this scrolls you to the content.
  // Delegated so the handlers survive the sku info AJAX refresh.
  $(document).on("click", ".TurnToReviewsTeaser", function () {
    let reviewTab = document.getElementById('reviews-content');
    const reviewCollapse = new bootstrap.Collapse(reviewTab, {
      toggle: false
    });
    reviewCollapse.show();
    reviewTab.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'start'
    });
  });
  $(document).on("click", ".write-review__ask", function () {
    let questionsTab = document.getElementById('questions-content');
    const questionsCollapse = new bootstrap.Collapse(questionsTab, {
      toggle: false
    });
    questionsCollapse.show();
    questionsTab.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'start'
    });
  });
  let dkTurnTo = new DK.TurnTo(dkTurnToConfiguration, dkTurnToConfiguration.ttProductId);
  // Set the dkTurnTo instance onto the window so that it can be reused
  window.DK.TurnTo.instance = dkTurnTo;

  // Load script tags after page has been rendered
  if (document.readyState === 'complete') {
    dkTurnTo.addScriptTags.bind(dkTurnTo)();
  } else {
    window.addEventListener('load', dkTurnTo.addScriptTags.bind(dkTurnTo), false);
  }
  if (window.location.hash === '#write-review') {
    // Scroll to the reviews section and open the Write a Review feature
    let turnToExists = window.setInterval(function () {
      if (typeof TurnTo != 'undefined') {
        dkTurnTo.writeReview();
        window.clearInterval(turnToExists);
      }
    }, 100);
  }
});
(function ($, window, undefined) {
  window.DK = window.DK || {};
  window.DK.TurnTo = TurnTo;
  function TurnTo(config, reviewId) {
    const self = this;
    self.turnToConfig = {
      sku: config.sku,
      locale: config.locale,
      pageId: config.pageId,
      site: config.site,
      siteKey: config.siteKey,
      staticEmbedBaseUrl: config.staticEmbedBaseUrl,
      reviewId: reviewId,
      reviewsSetupType: 'staticEmbed',
      setupType: 'staticEmbed',
      insertRelatedContentOnLoad: true,
      eventHandlers: {
        questionSubmit: self.turnToInvalidateQACache.bind(self),
        answerSubmit: self.turnToInvalidateQACache.bind(self),
        reviewSubmit: self.turnToInvalidateReviewCache.bind(self)
      },
      gallery: config.gallery
    };
    window.TurnToItemSku = reviewId;
    window.turnToConfig = self.turnToConfig;
  }
  DK.TurnTo.prototype.writeReview = function () {
    if (typeof TurnTo != 'undefined' && TurnTo.writeReview) {
      TurnTo.writeReview();
    }
  };

  // Re-renders the TurnTo widgets after their containers have been
  // replaced (e.g. the product tabs are reloaded via AJAX).
  DK.TurnTo.prototype.refresh = function (reviewId) {
    if (!reviewId || reviewId === this.turnToConfig.sku) {
      return;
    }
    this.turnToConfig.reviewId = reviewId;
    this.turnToConfig.sku = reviewId;
    window.TurnToItemSku = reviewId;
    if (typeof TurnToCmd === 'function') {
      TurnToCmd('set', {
        sku: reviewId
      });
    }
  };
  DK.TurnTo.prototype.turnToInvalidateCache = function (cacheType) {
    let xhr = new XMLHttpRequest();
    // Even though the reviews are at the product level, the
    // ProductReviewService takes the Sku to insulate us from
    // future changes to where reviews/Q&A are stored.
    let url = `/product/review-cache?productId=${this.turnToConfig.reviewId}
		&cacheType=${cacheType}`;
    xhr.open('POST', url, true);
    xhr.send();
  };
  DK.TurnTo.prototype.turnToInvalidateQACache = function () {
    this.turnToInvalidateCache('qa');
  };
  DK.TurnTo.prototype.turnToInvalidateReviewCache = function () {
    this.turnToInvalidateCache('review');
  };
  DK.TurnTo.prototype.addScriptTags = function () {
    let tt = document.createElement('script');
    tt.type = 'text/javascript';
    tt.async = true;
    tt.src = `https://widgets.turnto.com/v5/widgets/${this.turnToConfig.siteKey}
		/js/turnto.js`;
    let s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(tt, s);
  };
})(window.jQuery, window);
'use strict';

var DK = DK || {};
DK.AddToCart = DK.AddToCart || {
  // ID for the error message
  errorId: 'cart-error',
  init: function (purchaseFormId) {
    if ($(purchaseFormId).data('initialized') !== true) {
      $(purchaseFormId).on('submit', function (e) {
        e.preventDefault();
        $(`#${DK.AddToCart.errorId}`).fadeOut();
        DK.AddToCart.updateCart(purchaseFormId);
      });
    }
  },
  updateCart: function (purchaseFormId) {
    let $purchaseForm = $(purchaseFormId);
    let spinner = new Spinner();
    $.ajax({
      data: $purchaseForm.serialize(),
      url: $purchaseForm.attr('action'),
      method: $purchaseForm.attr('method'),
      beforeSend: function () {
        DK.displayBlocker('.product-details-page');
        spinner.spin($purchaseForm.get()[0]);
      },
      complete: function () {
        DK.hideBlocker('.product-details-page');
        $('.spinner').remove();
      }
    }).done(function (jsonData) {
      if (jsonData.status === 'success') {
        let skuIds = jsonData.itemsAddedToCart.map(item => item.skuId);
        let rideId = $('input[name="rideId"]').val();
        DK.AddToCart.updateCartStatus(jsonData.cartModalHTML, jsonData.cartItemsCount, jsonData.cartHTML);
        DK.AddToCart.sendListrakTracking(jsonData.listrakCart.items);
        DK.AddToCart.sendGoogleAnalyticsTracking(skuIds, rideId);
        DK.AddToCart.sendGTMTrigger(jsonData.cartItemsPrice, jsonData.itemsAddedToCart);
      } else if (jsonData.status === 'error') {
        $('#added-to-cart-modal').replaceWith(jsonData.cartModalHTML);
        bootstrap.Modal.getOrCreateInstance($('#added-to-cart-modal')[0]).show();
      } else if (jsonData.status === 'insufficientQuantity') {
        DK.AddToCart.insufficientQuantityError($purchaseForm, jsonData.quantity);
      }
    }).fail(function () {
      DK.AddToCart.displayErrors($purchaseForm);
    });
  },
  updateCartStatus: function (cartModalHTML, cartItemsCount, cartHTML) {
    $('.cart-message').fadeOut(function () {
      // Update the count in the header
      this.innerHTML = cartItemsCount;
    }).fadeIn();

    // Update the header dropdown
    $('#cart-header').replaceWith(cartHTML);

    // Replace the modal on the page with the rendered HTML
    $('#added-to-cart-modal').replaceWith(cartModalHTML);

    // Modal selector needs to be duplicated in order to select
    // the newly replaced HTML, as it replaces the entire modal
    new bootstrap.Modal($('#added-to-cart-modal')[0]).show();
  },
  displayErrors: function ($purchaseForm) {
    let $errorMessage = `<span class="message">An error occurred while adding item to cart.
			Please try again.</span>`;
    let $cartError = `<div id="${DK.AddToCart.errorId}" class="alert-info alert">
			${$errorMessage}</div>`;
    if ($purchaseForm.parents('.ob-item')) {
      $purchaseForm.parent().prepend($cartError);
    } else {
      $cartError.insertBefore($purchaseForm);
    }
  },
  insufficientQuantityError: function ($purchaseForm) {
    let $errorMessage = `<span class="message">This item can not be back ordered</span>`;
    let $cartError = `<div id="${DK.AddToCart.errorId}" class="alert alert-info">
			${$errorMessage}</div>`;
    if ($purchaseForm.parents('.ob-item')) {
      $purchaseForm.parent().prepend($cartError);
    } else {
      $cartError.insertBefore($purchaseForm);
    }
  },
  sendListrakTracking: function (cartItems) {
    if (DK.Tracking.Listrak.isAvailable()) {
      //Send cart information to Listrak for cart abandonment
      cartItems.forEach(item => {
        _ltk.SCA.AddItemWithLinks(item.skuId, item.quantity, item.amount.toString(), item.name, item.imagePath, item.seoUrl);
      });
      _ltk.SCA.Submit();
    }
  },
  sendGoogleAnalyticsTracking: function (skuIds, rideId) {
    skuIds.forEach(skuId => {
      let gaCategory = 'Add To Cart',
        gaAction = 'Ride Inactive',
        gaLabel = '';
      if (rideId) {
        gaLabel = `rideId=${rideId}; skuId=${skuId};`;
        gaAction = 'Ride Active';
      } else {
        gaLabel = `skuId=${skuId}`;
      }
      ga('send', 'event', gaCategory, gaAction, gaLabel);
    });
  },
  sendGTMTrigger: function (cartItemsPrice, itemsAddedToCart) {
    window.dataLayer.push({
      cartItemsPrice: cartItemsPrice,
      itemsAddedToCart: itemsAddedToCart,
      event: 'dk.add-to-cart'
    });
  }
};
$(function () {
  DK.AddToCart.init('.add-to-cart-ajax');
  $('.add-to-cart-ajax').attr('data-initialized', true);
});
'use strict';

(function ($, window, undefined) {
  window.DK.GiftListSelector = GiftListSelector;
  $.fn.giftList = function (options) {
    function addItemsToList(currentTarget, list, giftListSelector) {
      let items = window.DK.giftListItems.map(function (input, i) {
        return giftListSelector.createListItem(list.id, input.skuId, input.price, input.quantity);
      });
      giftListSelector.addItemsToList(list.id, items).done(function (data) {
        displayGiftListFeedback(data, $(currentTarget), list);
        document.dispatchEvent(new CustomEvent('add-items-to-gift-list-event'));
      });
    }
    function displayGiftListFeedback(data, $elm, giftList) {
      if (data.failure || !data.itemAdded) {
        return;
      }
      bootstrap.Modal.getInstance($('.modal.show')[0]).hide();
      displayToast(giftList);
    }
    function displayToast(giftList) {
      const header = `Item Added to ${giftList.type}`;
      const body = `<a href="/gift-list/details?registryId=${giftList.id}">Go to your ${giftList.name}
			${giftList.type.toLocaleLowerCase()}</a>`;
      $.toast({
        type: 'success',
        title: header,
        content: body,
        delay: 5000
      });
    }

    /**
     * Attaches the new gift list button event handlers to the modal
     * after the modal is displayed.
     * @param event 'shown.bs.modal' Bootstrap modal event
     */
    function onNewListModalShown(event) {
      let relatedTarget = $(event.relatedTarget);
      let data = eval(relatedTarget.data('gl'));
      window.DK.giftListItems = data;
    }
    return this.each(function (index, element) {
      let giftListSelector = new GiftListSelector(element);

      // Attaches the 'click' event handler to each gift list in
      // the dropdown menu to allow adding an item to that gift list.
      giftListSelector.giftLists.forEach(function (list) {
        $(list.element).off('click').on('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          addItemsToList(e.currentTarget, list, giftListSelector);
        });
      });

      // Set up event handlers for the 'Create new wish list/gift
      // registry' buttons inside of the modal. This loads the forms
      // inside of the existing modal rather than loading a new page.
      //$(giftListSelector.createNewButton).on('click', onCreateNewListClick);
      $('#gift-list-modal').on('shown.bs.modal', onNewListModalShown);
      this.giftListSelector = giftListSelector;
      $.data(this, 'giftListSelector', giftListSelector);
      return this;
    });
  };
  function GiftListSelector(elem) {
    this.elem = elem;
    this.$elem = $(elem);
    this.createNewButton = elem.querySelector('.create-new > a');
    this.giftLists = Array.from(elem.querySelectorAll('.giftlist-add-item')).map(function (el) {
      return {
        id: el.id,
        element: el,
        name: el.querySelector('.gift-list-name').textContent,
        type: el.querySelector('.list-title').textContent
      };
    });
  }
  GiftListSelector.prototype.createListItem = function (listId, skuId, price, quantity) {
    if (!listId) {
      throw new Error('listId is required');
    }
    if (!skuId) {
      throw new Error('Invalid sku id');
    }
    if (!price) {
      throw new Error('Price is required');
    }
    let list = this.findListById(listId);
    if (!list) {
      throw new Error(`Unable to find a list with id: ${listId}`);
    }
    return {
      giftListId: list.id,
      giftListName: list.name,
      skuId: skuId,
      addedPrice: price,
      requestQty: quantity || 1
    };
  };
  GiftListSelector.prototype.addItemsToList = function (listId, itemsToAdd) {
    let spinner = new Spinner(),
      $content = this.$elem.find('.modal-content');
    return $.ajax({
      type: 'POST',
      url: '/gift-list/add-item',
      contentType: 'application/json; charset=utf-8',
      data: JSON.stringify(itemsToAdd),
      dataType: 'json',
      beforeSend: function () {
        DK.displayBlocker($content);
        spinner.spin($content.get()[0]);
      },
      complete: function () {
        DK.hideBlocker($content);
        spinner.stop();
      }
    });
  };
  GiftListSelector.prototype.findListById = function (listId) {
    let lists = this.giftLists.filter(function (e) {
      return e.id === listId;
    });
    if (!lists) {
      return;
    }
    return lists[0];
  };
})(window.jQuery, window);
$(function () {
  $('#gift-list-modal').giftList();
});

//Reset gift list modal when it's closed
//only add listener if modal exists.

if ($('#gift-list-modal').length) {
  /* Because this is written badly, we were using the same selector to do
  two different things and when we combined the script caused both to run. This
  adds a differentiator to determine whether to add and item to move one*/
  // $(this).giftList();
  let toMove = $('.js-move-sku-id').length;
  if (toMove) {
    $('#gift-list-modal').addClass('gift-list-modal--move');
  }
}

/* This was in the old gift-lists.js and we combined them into
 ** one file to avoid the ridiculous confusion that came along with that.
 ** These are written terribly, i am sorry to whoever has to look at them
 ** until they are rewritten */
var DK = DK || {};
DK.GiftLists = {
  // Initialize the giftlist page handlers
  init: function () {
    // Click Event to get the sku-id from the _gift-list-item.vm
    $('.js-move-sku-id').on('click', function (e) {
      e.preventDefault();
      DK.GiftLists.getSkuIdToMove($(this));
    });
    $('.gift-list-modal--move [data-giftlist-id]').on('click', function (e) {
      e.preventDefault();
      DK.GiftLists.moveItemToDifferentGiftListOrRegistry($(this));
    });
  },
  getSkuIdToMove: function ($elm) {
    $('.add-to-giftlist a').data('sku-id', $elm.data('gl-sku-id'));
  },
  moveItemToDifferentGiftListOrRegistry: function ($elm) {
    const wlIdFrom = $elm.data('giftlist-id'); //Id of the wish list the item is being moved from
    const wlIdTo = $elm.data('gl-id'); //Id of the wish list the item is being moved to
    const skuId = $elm.data('sku-id');
    const giftListName = $elm.find('span.gift-list-name').text();
    const giftListType = $elm.find('span.list-title').text();
    let spinner = new Spinner();
    $.ajax({
      type: 'POST',
      async: true,
      url: '/gift-list/move-item',
      contentType: 'application/json; charset=utf-8',
      data: JSON.stringify({
        giftListIdTo: wlIdTo,
        giftListIdFrom: wlIdFrom,
        skuId: skuId
      }),
      beforeSend: function () {
        DK.displayBlocker('#registry-form');
        spinner.spin($elm.get()[0]);
      },
      dataType: 'json',
      context: this
    }).always(function (data) {
      $(`li[data-sku-id='${skuId}'], .cart-sfl__item`).hide();
      bootstrap.Modal.getInstance($('#gift-list-modal')[0]).hide();
      displayToast(wlIdTo, giftListName, giftListType);
      if (data.isEmpty) {
        $('#registry-form').replaceWith(data.emptyHtml);
      }
      DK.hideBlocker('#registry-form');
      spinner.stop();
    }).fail(function (xhr, textStatus, errorThrown) {
      if (window.console) {
        console.log('Error: ' + errorThrown + '\n' + 'Status: ' + textStatus);
        DK.hideBlocker('#registry-form');
        spinner.stop();
      }
      DK.hideBlocker('#registry-form');
      spinner.stop();
    });
  }
};
function displayToast(giftListId, giftListName, giftListType) {
  const header = `Item moved to ${giftListType}`;
  const body = `<a href="/gift-list/details?registryId=${giftListId}">
	Go to your ${giftListName} ${giftListType.toLocaleLowerCase()}</a>`;
  $.toast({
    type: 'success',
    title: header,
    content: body,
    delay: 5000
  });
}
$(function () {
  // Adds item to cart via ajax
  $('a[data-add-cart]').on('click', function (e) {
    e.preventDefault();
    const $elm = $(this);
    const itemPlace = $elm.attr('data-add-cart');
    const skuId = $elm.attr('data-sku-id');
    const registryId = $elm.attr('data-registry-id');
    const itemQuantity = $('#' + itemPlace).val();
    let spinner = new Spinner();
    $.ajax({
      data: {
        skuId: skuId,
        registryId: registryId,
        quantity: itemQuantity
      },
      url: $elm.attr('href'),
      method: 'POST',
      beforeSend: function () {
        DK.displayBlocker('#registry-form');
        spinner.spin($('#registry-form').get()[0]);
      },
      complete: function () {
        DK.hideBlocker('#registry-form');
        spinner.stop();
      },
      success: function (jsonData) {
        let skuIds = jsonData.itemsAddedToCart.map(item => item.skuId);
        let rideId = $("input[name='rideId']").val();
        DK.AddToCart.updateCartStatus(jsonData.cartModalHTML, jsonData.cartItemsCount, jsonData.cartHTML);
        DK.AddToCart.sendListrakTracking(jsonData.listrakCart.items);
        DK.AddToCart.sendGoogleAnalyticsTracking(skuIds, rideId);
        DK.AddToCart.sendGTMTrigger(jsonData.itemsAddedToCart);
      }
    });
  });

  // Initialize the add to cart javascript on each form
  document.querySelectorAll('form[id^=add-to-cart-form]').forEach(form => DK.AddToCart.init(`#${form.id}`));

  /**
   * Handle the email functionality. A modal dialog containing the form
   * is displayed to the user and any failed form validation should
   * remain in the modal. The modal is hidden upon successful form
   * submission and a message will be displayed to the user.
   */
  $(document).off('submit', '#registry-email-to-friend-modal form');
  $(document).on('submit', '#registry-email-to-friend-modal form', function (e) {
    e.preventDefault();
    let spinner = new Spinner();
    $.ajax({
      url: $(this).attr('action'),
      data: $(this).serialize(),
      type: $(this).attr('method'),
      beforeSend: function () {
        DK.displayBlocker('#registry-email-to-friend-modal');
        spinner.spin($('#registry-email-to-friend-modal').get()[0]);
      },
      complete: function () {
        DK.hideBlocker('#registry-email-to-friend-modal');
        spinner.stop();
      }
    }).done(function (data, textStatus, jqXHR) {
      let $html = $(data);
      let $modal = $('#registry-email-to-friend-modal');
      // Use the returned element id to determine if the form
      // submission passed or failed validation
      if ($html[0].id === 'success-message') {
        bootstrap.Modal.getInstance($modal[0]).hide();
        let $messageDiv = $('#registry-messages'),
          messageContent = $(data).html();
        $messageDiv.find('.alert').html(messageContent);
        $messageDiv.show();
      } else {
        let modalContent = $(data)[0];
        $modal.find('.modal-body-content').html(modalContent);
        bootstrap.Modal.getInstance($modal[0]).handleUpdate();
      }
    });
  });

  /**
   * Handle the 'edit details' modal submission.
   */
  $(document).off('submit', 'form#edit-details');
  $(document).on('submit', 'form#edit-details', function (e) {
    e.preventDefault();
    let spinner = new Spinner();
    $.ajax({
      url: this.action,
      data: $(this).serialize(),
      method: this.method,
      beforeSend: function () {
        $('#edit-details-messages').hide();
        DK.displayBlocker('#edit-details');
        spinner.spin($('#edit-details').get()[0]);
      },
      complete: function () {
        DK.hideBlocker('form.content');
        spinner.stop();
      }
    }).done(function (data, textStatus, jqXHR) {
      if (jqXHR.status === 202) {
        // Successful form submission returns a HTTP 202 Accepted
        // status code
        bootstrap.Modal.getInstance($('#gift-list-create')[0]).hide();
        window.location.reload(true);
      } else {
        let modalContent = $(data)[0];
        $('#giftListContent').html(modalContent);
      }
      $('<div class="alert-box success">Wish List has been successfully saved</div>').insertBefore('#edit-details');
    }).fail(function (jqXHR, textStatus, errorThrown) {
      $('#edit-details-messages .alert-box').text('An error occurred. Please try again.');
      $('#edit-details-messages').show();
    });
  });
  let currentPos;
});
$(function () {
  DK.GiftLists.init();

  //Reset gift list modal when it's closed
  //only add listener if modal exists.
  if ($('#gift-list-create').length) {
    $('#gift-list-create')[0].addEventListener('shown.bs.modal', function (e) {
      /* The related target needs the giftList item object attached to it,
       ** This should be separate attributes. Needs to be addressed when this is
       ** rewritten. */
      if (window.DK.giftListItems && window.DK.giftListItems.length > 0) {
        let data = window.DK.giftListItems[0];
        let dataSet = `[{skuId: '${data.skuId}', price: '${data.price}', quantity: '${data.quantity}'}]`;
        $('.gl__form__cta--back').attr('data-gl', dataSet);
      }
    });
  }
});
(function ($, window, undefined) {
  window.DK = window.DK || {};
  window.DK.FitmentSelector = FitmentSelector;
  $.fn.fitmentSelector = function (options) {
    return this.each(function (index, element) {
      let fitmentSelector = new FitmentSelector(element);
      this.fitmentSelector = fitmentSelector;
      $.data(this, 'fitmentSelector', fitmentSelector);
      return this;
    });
  };
  function FitmentSelector(element) {
    this.element = element;
    this.makes = Array.from(this.element.querySelectorAll('.fm')).map(function (makeEl) {
      return {
        element: makeEl,
        name: makeEl.querySelector('.make-heading [data-name]').getAttribute('data-name'),
        models: Array.from(makeEl.querySelectorAll('.fm__list__item')).map(function (modelEl) {
          return {
            element: modelEl,
            name: modelEl.getAttribute('data-name')
          };
        })
      };
    });
    this.$searchInput = $(this.element).find('#filter-fitment');
    this.$searchInput.on('input', this.filterChange.bind(this));
  }

  /**
   * Event handler for when a user types in the fitment search input
   * @param event 'input' DOM event (or similar originating from a text input)
   **/
  FitmentSelector.prototype.filterChange = function (event) {
    let searchString = event.target.value.trim().toLowerCase().replace(/[-\W]+/g, '');
    if (searchString) {
      this.makes.forEach(function (make) {
        let makeMatchesSearch = make.name.toLowerCase().replace(/[-\W]+/g, '').indexOf(searchString) > -1;
        let matchingModels = make.models.filter(function (model) {
          return model.name.toLowerCase().replace(/[-\W]+/g, '').indexOf(searchString) > -1;
        });
        if (makeMatchesSearch) {
          // Make name matches. Display all available models
          // for that make
          $(make.element).show();
          make.models.forEach(function (model) {
            $(model.element).show();
          });
        } else if (matchingModels.length > 0) {
          // Make name does not match, but there are models that
          // do match. Display the make and any matching models.
          $(make.element).show();
          make.models.forEach(function (model) {
            let $model = $(model.element);
            if (model.name.indexOf(searchString) > -1) {
              $model.show();
            } else {
              $model.hide();
            }
          });
        } else {
          // Make does not match and neither does any of the models
          // for that make. Hide the entire make to indicate no matches
          $(make.element).hide();
        }
      });
    } else {
      // The search string is empty - display all makes and models
      this.makes.forEach(function (make) {
        $(make.element).show();
        make.models.forEach(function (model) {
          $(model.element).show();
        });
      });
    }
  };
})(window.jQuery, window);
$(function () {
  $('#fitment-content .product-tabs-fitment').fitmentSelector();
});
//# sourceMappingURL=product-bundle.js.map
